"use strict";
(self["webpackChunksrc"] = self["webpackChunksrc"] || []).push([["custom"],{

/***/ "./src/ts/components/common/Button.tsx":
/*!*********************************************!*\
  !*** ./src/ts/components/common/Button.tsx ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Button": () => (/* binding */ Button)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../hooks/useIsMobile */ "./src/ts/hooks/useIsMobile.tsx");
/* harmony import */ var _ButtonPreventDefault__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ButtonPreventDefault */ "./src/ts/components/common/ButtonPreventDefault.tsx");
/* harmony import */ var _Spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Spinner */ "./src/ts/components/common/Spinner.tsx");




var buttons = {
  cart: {
    alt: 'cart',
    src: '//cdn.shopify.com/s/files/1/0487/6795/9189/t/69/assets/t-sidebar-cart.svg?v=9482979743328782007'
  },
  customize: {
    alt: 'customize',
    src: '//cdn.shopify.com/s/files/1/0487/6795/9189/t/69/assets/t-icon-customize.svg?v=17110406610069329096'
  }
};
var Button = function Button(_ref) {
  var onClick = _ref.onClick,
    type = _ref.type,
    content = _ref.content,
    _ref$checkout = _ref.checkout,
    checkout = _ref$checkout === void 0 ? false : _ref$checkout,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? '' : _ref$style,
    _ref$submitting = _ref.submitting,
    submitting = _ref$submitting === void 0 ? false : _ref$submitting,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_1__.useIsMobile)();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonPreventDefault__WEBPACK_IMPORTED_MODULE_2__.ButtonPreventDefault, {
    onClick: onClick,
    id: checkout ? 'js-checkout-button' : "button-".concat(type, "-").concat(Math.random().toFixed(1).toString()),
    className: "".concat(disabled ? 'opacity-50 pointer-events-none' : 'active:ring-4 active:ring-primary-200 focus:outline-none focus:ring-4 focus:ring-primary-300  hover:bg-primary-600', " flex t-shadow transform duration-200 items-center justify-center w-full h-14 md:h-16 text-white rounded-md bg-towel-light-wine ").concat(style).trim(),
    disabled: disabled,
    style: {
      minWidth: '150px'
    }
  }, !submitting ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !isMobile && type && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    alt: buttons[type].alt,
    src: buttons[type].src,
    className: "w-10 md:w-16"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "text-sm font-medium text-white nd:text-base"
  }, content)) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Spinner__WEBPACK_IMPORTED_MODULE_3__.Spinner, {
    color: "#fff"
  })));
};

/***/ }),

/***/ "./src/ts/components/common/ButtonPreventDefault.tsx":
/*!***********************************************************!*\
  !*** ./src/ts/components/common/ButtonPreventDefault.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ButtonPreventDefault": () => (/* binding */ ButtonPreventDefault)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var ButtonPreventDefault = function ButtonPreventDefault(_ref) {
  var _onClick = _ref.onClick,
    children = _ref.children,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    id: id,
    style: style,
    disabled: disabled,
    className: className,
    onClick: function onClick(e) {
      e.preventDefault();
      _onClick(e);
    }
  }, children);
};

/***/ }),

/***/ "./src/ts/components/common/ButtonWithSign.tsx":
/*!*****************************************************!*\
  !*** ./src/ts/components/common/ButtonWithSign.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ButtonWithSign": () => (/* binding */ ButtonWithSign)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _ButtonPreventDefault__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ButtonPreventDefault */ "./src/ts/components/common/ButtonPreventDefault.tsx");


var ButtonWithSign = function ButtonWithSign(_ref) {
  var classes = _ref.classes,
    sign = _ref.sign,
    content = _ref.content,
    onClick = _ref.onClick;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonPreventDefault__WEBPACK_IMPORTED_MODULE_1__.ButtonPreventDefault, {
    onClick: onClick,
    className: "flex transform duration-200 cursor-pointer items-center justify-center px-8 my-2 font-medium ".concat(classes).trim()
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "text-white text-3xl"
  }, sign), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "text-white ml-3"
  }, content));
};

/***/ }),

/***/ "./src/ts/components/common/CartAssetItem.tsx":
/*!****************************************************!*\
  !*** ./src/ts/components/common/CartAssetItem.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CartAssetItem": () => (/* binding */ CartAssetItem)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/constants */ "./src/ts/utils/constants.ts");


var CartAssetItem = function CartAssetItem(_ref) {
  var name = _ref.name,
    index = _ref.index,
    onClick = _ref.onClick,
    selected = _ref.selected,
    assetName = _ref.assetName;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    key: name.toString(),
    className: "p-2 border ".concat(selected ? 'border-wine ring-2 ring-wine ring-inset' : 'border-white'),
    onClick: onClick
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: "".concat(_utils_constants__WEBPACK_IMPORTED_MODULE_1__.BASE_ASSET_URL, "/").concat(assetName).concat(index, ".jpg"),
    width: "300",
    draggable: "false",
    height: "200",
    alt: name.toString(),
    className: "w-11/12 mx-auto lg:w-3/4"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "text-center"
  }, name));
};

/***/ }),

/***/ "./src/ts/components/common/CartGreyButton.tsx":
/*!*****************************************************!*\
  !*** ./src/ts/components/common/CartGreyButton.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CartGreyButton": () => (/* binding */ CartGreyButton)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _ButtonPreventDefault__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ButtonPreventDefault */ "./src/ts/components/common/ButtonPreventDefault.tsx");


var CartGreyButton = function CartGreyButton(_ref) {
  var onClick = _ref.onClick,
    children = _ref.children,
    submitting = _ref.submitting;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonPreventDefault__WEBPACK_IMPORTED_MODULE_1__.ButtonPreventDefault, {
    disabled: submitting,
    className: "flex items-center justify-center lg:px-4 px-2 text-xs font-medium text-black h-7 lg:text-sm t-gray-button ".concat(submitting ? 'pointer-events-none' : '').trimEnd(),
    onClick: onClick
  }, children);
};

/***/ }),

/***/ "./src/ts/components/common/CartOneItem.tsx":
/*!**************************************************!*\
  !*** ./src/ts/components/common/CartOneItem.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CartOneItem": () => (/* binding */ CartOneItem)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _common_CartOneItemWithoutImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/CartOneItemWithoutImage */ "./src/ts/components/common/CartOneItemWithoutImage.tsx");


var CartOneItem = function CartOneItem(_ref) {
  var item = _ref.item,
    children = _ref.children,
    showLabel = _ref.showLabel;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: item.image,
    alt: item.title,
    height: "256",
    width: "384",
    className: "object-contain col-span-2 w-52 aspect-ratio-square lg:w-80 place-self-start xl:place-self-auto xl:col-span-1",
    loading: "lazy"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "grid grid-cols-2 col-span-2 col-start-2 gap-3 xl:col-span-3 xl:grid-cols-3 lg:gap-4 place-self-start xl:place-self-auto xl:col-start-auto "
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_common_CartOneItemWithoutImage__WEBPACK_IMPORTED_MODULE_1__.CartOneItemWithoutImage, {
    item: item,
    showLabel: showLabel
  }), children));
};

/***/ }),

/***/ "./src/ts/components/common/CartOneItemWithoutImage.tsx":
/*!**************************************************************!*\
  !*** ./src/ts/components/common/CartOneItemWithoutImage.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CartOneItemWithoutImage": () => (/* binding */ CartOneItemWithoutImage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");
/* harmony import */ var _cart_CartServiceLabel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../cart/CartServiceLabel */ "./src/ts/components/cart/CartServiceLabel.tsx");
/* harmony import */ var _EmbroLabel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./EmbroLabel */ "./src/ts/components/common/EmbroLabel.tsx");




var CartOneItemWithoutImage = function CartOneItemWithoutImage(_ref) {
  var item = _ref.item,
    showLabel = _ref.showLabel;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "col-span-2 text-base font-medium text-black xl:col-span-3 lg:text-lg"
  }, item.title), showLabel && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_cart_CartServiceLabel__WEBPACK_IMPORTED_MODULE_2__.CartServiceLabel, {
    item: item
  }), item.properties._shishu_text && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EmbroLabel__WEBPACK_IMPORTED_MODULE_3__.EmbroLabel, {
    name: _utils_TEXT__WEBPACK_IMPORTED_MODULE_1__["default"].CART.COMMON.EMBRO,
    property: item.properties._shishu_text
  }), item.properties._mark_name && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EmbroLabel__WEBPACK_IMPORTED_MODULE_3__.EmbroLabel, {
    name: _utils_TEXT__WEBPACK_IMPORTED_MODULE_1__["default"].CART.COMMON.MOTIF,
    property: item.properties._mark_name
  }), !item.properties._shishu_text && !item.properties._mark_code && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EmbroLabel__WEBPACK_IMPORTED_MODULE_3__.EmbroLabel, {
    name: _utils_TEXT__WEBPACK_IMPORTED_MODULE_1__["default"].CART.COMMON.NO_EMBRO
  }));
};

/***/ }),

/***/ "./src/ts/components/common/CartStepTitle.tsx":
/*!****************************************************!*\
  !*** ./src/ts/components/common/CartStepTitle.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CartStepTitle": () => (/* binding */ CartStepTitle)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_cartActions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/cartActions */ "./src/ts/utils/cartActions.ts");
/* harmony import */ var _utils_contexts_CartContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/contexts/CartContext */ "./src/ts/utils/contexts/CartContext.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");




var CartStepTitle = function CartStepTitle(_ref) {
  var title1 = _ref.title1,
    _ref$title = _ref.title2,
    title2 = _ref$title === void 0 ? '' : _ref$title,
    _ref$clear = _ref.clear,
    clear = _ref$clear === void 0 ? true : _ref$clear;
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_CartContext__WEBPACK_IMPORTED_MODULE_2__.CartContext),
    state = _useContext.cartState;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "__cart_title"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "my-2 text-xl font-normal text-center text-black lg:my-4 lg:text-2xl lg:font-medium"
  }, title1), state.errorMessage && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "text-xs text-center text-red-600 mt-2"
  }, state.errorMessage), clear && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "text-xs text-right underline cursor-pointer hover:opacity-75 hover:no-underline md:text-base",
    onClick: _utils_cartActions__WEBPACK_IMPORTED_MODULE_1__.deleteAll
  }, _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].CART.COMMON.CLEAR), title2 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "mb-5"
  }, title2));
};

/***/ }),

/***/ "./src/ts/components/common/CustomizeImg.tsx":
/*!***************************************************!*\
  !*** ./src/ts/components/common/CustomizeImg.tsx ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomizeImg": () => (/* binding */ CustomizeImg)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var CustomizeImg = function CustomizeImg(_ref) {
  var src = _ref.src,
    alt = _ref.alt;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    draggable: "false",
    loading: "lazy",
    width: "500",
    height: "500",
    src: src,
    alt: alt
  });
};

/***/ }),

/***/ "./src/ts/components/common/DeleteButton.tsx":
/*!***************************************************!*\
  !*** ./src/ts/components/common/DeleteButton.tsx ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DeleteButton": () => (/* binding */ DeleteButton)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _CartGreyButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CartGreyButton */ "./src/ts/components/common/CartGreyButton.tsx");
/* harmony import */ var _Spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Spinner */ "./src/ts/components/common/Spinner.tsx");



var DeleteButton = function DeleteButton(_ref) {
  var onDelete = _ref.onDelete,
    _ref$deleting = _ref.deleting,
    deleting = _ref$deleting === void 0 ? false : _ref$deleting;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CartGreyButton__WEBPACK_IMPORTED_MODULE_1__.CartGreyButton, {
    onClick: onDelete,
    submitting: deleting
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "mr-1 text-3xl transform rotate-45"
  }, "+"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, !deleting ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, "\u524A\u9664") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Spinner__WEBPACK_IMPORTED_MODULE_2__.Spinner, {
    color: "#000",
    num: 25
  })));
};

/***/ }),

/***/ "./src/ts/components/common/EmbroLabel.tsx":
/*!*************************************************!*\
  !*** ./src/ts/components/common/EmbroLabel.tsx ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EmbroLabel": () => (/* binding */ EmbroLabel)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var EmbroLabel = function EmbroLabel(_ref) {
  var name = _ref.name,
    property = _ref.property;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "col-start-1 text-xs lg:text-sm"
  }, name), property && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "text-xs text-black break-all"
  }, property));
};

/***/ }),

/***/ "./src/ts/components/common/ModalActions.tsx":
/*!***************************************************!*\
  !*** ./src/ts/components/common/ModalActions.tsx ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ModalActions": () => (/* binding */ ModalActions)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _ButtonPreventDefault__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ButtonPreventDefault */ "./src/ts/components/common/ButtonPreventDefault.tsx");


var ModalActions = function ModalActions(_ref) {
  var name1 = _ref.name1,
    name2 = _ref.name2,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onClick1 = _ref.onClick1,
    onClick2 = _ref.onClick2;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex justify-around"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonPreventDefault__WEBPACK_IMPORTED_MODULE_1__.ButtonPreventDefault, {
    className: "w-30 hover:border-gray-500 hover:bg-gray-400 border border-transparent focus:border-wine focus:outline-none transform duration-200 lg:w-44 lg:h-14 h-10 mt-5 text-black px-10 rounded bg-towel-cart-warm-gray ",
    onClick: onClick1
  }, name1), name2 && onClick2 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonPreventDefault__WEBPACK_IMPORTED_MODULE_1__.ButtonPreventDefault, {
    className: "w-30 lg:w-44 hover:border-gray-500 border-white border border-transparent focus:border-primary-700 focus:outline-none transform duration-200 lg:h-14 h-10 mt-5 text-white rounded bg-wine px-10 ".concat(disabled ? 'opacity-50 pointer-events-none' : '').trimEnd(),
    onClick: onClick2
  }, name2));
};

/***/ }),

/***/ "./src/ts/components/common/MotifPreviewCore.tsx":
/*!*******************************************************!*\
  !*** ./src/ts/components/common/MotifPreviewCore.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MotifPreviewCore": () => (/* binding */ MotifPreviewCore)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var MotifPreviewCore = function MotifPreviewCore(_ref) {
  var imageWidth = _ref.imageWidth,
    fontSize = _ref.fontSize,
    characterColor = _ref.characterColor,
    characterFont = _ref.characterFont,
    characterText = _ref.characterText,
    motifShow = _ref.motifShow,
    motifPath = _ref.motifPath;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, motifShow && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: motifPath,
    draggable: "false",
    width: Number.isNaN(imageWidth) ? 0 : imageWidth
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "".concat(characterFont, " select-text whitespace-pre"),
    style: {
      fontSize: fontSize + 'px',
      color: characterColor,
      // overflow: 'hidden',
      lineHeight: fontSize + 'px',
      paddingLeft: characterFont === 'font-pinyon' ? fontSize / 2 + 'px' : 0
    }
  }, characterText));
};

/***/ }),

/***/ "./src/ts/components/common/PriceLabel.tsx":
/*!*************************************************!*\
  !*** ./src/ts/components/common/PriceLabel.tsx ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PriceLabel": () => (/* binding */ PriceLabel)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _PriceNumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./PriceNumber */ "./src/ts/components/common/PriceNumber.tsx");


var PriceLabel = function PriceLabel(_ref) {
  var name = _ref.name,
    price = _ref.price;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "col-start-1 text-towel-cart-gray-middle"
  }, name), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_PriceNumber__WEBPACK_IMPORTED_MODULE_1__.PriceNumber, {
    price: price
  }));
};

/***/ }),

/***/ "./src/ts/components/common/PriceNumber.tsx":
/*!**************************************************!*\
  !*** ./src/ts/components/common/PriceNumber.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PriceNumber": () => (/* binding */ PriceNumber)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var PriceNumber = function PriceNumber(_ref) {
  var price = _ref.price;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "text-sm text-black"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "text-lg font-semibold"
  }, price), "\u5186(\u7A0E\u8FBC\u307F)");
};

/***/ }),

/***/ "./src/ts/components/common/QuantitySelection.tsx":
/*!********************************************************!*\
  !*** ./src/ts/components/common/QuantitySelection.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QuantitySelection": () => (/* binding */ QuantitySelection)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _ButtonPreventDefault__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ButtonPreventDefault */ "./src/ts/components/common/ButtonPreventDefault.tsx");


var QuantitySelection = function QuantitySelection(_ref) {
  var handleChange = _ref.handleChange,
    quantity = _ref.quantity,
    index = _ref.index;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "col-start-1"
  }, "\u6570\u91CF"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex items-center justify-start"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonPreventDefault__WEBPACK_IMPORTED_MODULE_1__.ButtonPreventDefault, {
    onClick: function onClick() {
      return quantity > 1 && handleChange(-1, false, index);
    },
    className: "w-8 h-8 text-xl font-semibold lg:w-10 lg:h-10 lg:text-3xl ring-2 ring-gray-200 t-gray-button"
  }, "-"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", {
    type: "number",
    className: "w-12 h-10 mx-2 text-center lg:w-16 lg:h-12 t-input-box t-quantity-input",
    value: Math.abs(quantity),
    onChange: function onChange(e) {
      return handleChange(Math.max(+e.target.value, 1), true, index);
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonPreventDefault__WEBPACK_IMPORTED_MODULE_1__.ButtonPreventDefault, {
    onClick: function onClick() {
      return handleChange(1, false, index);
    },
    className: "w-8 h-8 text-xl font-semibold lg:w-10 lg:h-10 lg:text-3xl ring-2 ring-gray-200 t-gray-button"
  }, "+")));
};

/***/ }),

/***/ "./src/ts/components/common/QuestionMark.tsx":
/*!***************************************************!*\
  !*** ./src/ts/components/common/QuestionMark.tsx ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QuestionMark": () => (/* binding */ QuestionMark)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var QuestionMark = function QuestionMark(_ref) {
  var text = _ref.text,
    _ref$src = _ref.src,
    src = _ref$src === void 0 ? '#' : _ref$src;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex items-center justify-start col-start-1 mt-3 text-sm md:text-base lg:mt-6"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex items-center justify-center w-5 h-5 text-sm font-extrabold text-white rounded-full bg-towel-product-gray-dark"
  }, "?"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: src,
    className: "ml-2 text-sm text-gray-600 border-b border-gray-400"
  }, text));
};

/***/ }),

/***/ "./src/ts/components/common/ServiceLabel.tsx":
/*!***************************************************!*\
  !*** ./src/ts/components/common/ServiceLabel.tsx ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ServiceLabel": () => (/* binding */ ServiceLabel)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var ServiceLabel = function ServiceLabel(_ref) {
  var service = _ref.service,
    _ref$start = _ref.start,
    start = _ref$start === void 0 ? true : _ref$start;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "p-1 text-xs flex justify-center items-center lg:p-2 md:text-base bg-towel-product-gray-light text-towel-product-gray-middle cart-service-item-label ".concat(start ? 'place-self-start' : '')
  }, service);
};

/***/ }),

/***/ "./src/ts/components/common/Spinner.tsx":
/*!**********************************************!*\
  !*** ./src/ts/components/common/Spinner.tsx ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Spinner": () => (/* binding */ Spinner)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var Spinner = function Spinner(_ref) {
  var color = _ref.color,
    _ref$num = _ref.num,
    num = _ref$num === void 0 ? 38 : _ref$num;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: num,
    height: num,
    viewBox: "0 0 38 38",
    stroke: color
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: "2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    strokeOpacity: ".5",
    cx: "18",
    cy: "18",
    r: "18"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "1s",
    repeatCount: "indefinite"
  })))));
};

/***/ }),

/***/ "./src/ts/components/common/TextareaCart.tsx":
/*!***************************************************!*\
  !*** ./src/ts/components/common/TextareaCart.tsx ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TextareaCart": () => (/* binding */ TextareaCart)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var TextareaCart = function TextareaCart(_ref) {
  var value = _ref.value,
    id = _ref.id,
    onChange = _ref.onChange,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("textarea", {
    name: id,
    placeholder: placeholder,
    onChange: onChange,
    className: "w-full h-40 mt-5 text-black t-input-box",
    id: id,
    cols: 30,
    value: value
  });
};

/***/ }),

/***/ "./src/ts/components/common/UnderCellText.tsx":
/*!****************************************************!*\
  !*** ./src/ts/components/common/UnderCellText.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UnderCellText": () => (/* binding */ UnderCellText)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var UnderCellText = function UnderCellText(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "mt-1 text-xs font-light text-center whitespace-pre lg:text-sm md:mt-3 md:text-base"
  }, text);
};

/***/ }),

/***/ "./src/ts/components/common/WarningText.tsx":
/*!**************************************************!*\
  !*** ./src/ts/components/common/WarningText.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WarningText": () => (/* binding */ WarningText)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var WarningText = function WarningText(_ref) {
  var children = _ref.children,
    _ref$red = _ref.red,
    red = _ref$red === void 0 ? true : _ref$red;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "text-xs select-text md:text-sm ".concat(red ? 'text-towel-product-red' : 'text-black', " ")
  }, children);
};

/***/ }),

/***/ "./src/ts/components/common/WhichGift.tsx":
/*!************************************************!*\
  !*** ./src/ts/components/common/WhichGift.tsx ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WhichGift": () => (/* binding */ WhichGift)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");
/* harmony import */ var _utils_type_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/type.helper */ "./src/ts/utils/type.helper.ts");



var WhichGift = function WhichGift(_ref) {
  var index = _ref.index,
    gift = _ref.gift;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, index + 1, '.', gift.type === _utils_type_helper__WEBPACK_IMPORTED_MODULE_2__.ProductType.GIFT_BOX ? _utils_TEXT__WEBPACK_IMPORTED_MODULE_1__["default"].CART.COMMON.GIFTBOX : _utils_TEXT__WEBPACK_IMPORTED_MODULE_1__["default"].CART.COMMON.WRAPPING);
};

/***/ }),

/***/ "./src/ts/hooks/useAddCart.tsx":
/*!*************************************!*\
  !*** ./src/ts/hooks/useAddCart.tsx ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useAddCart": () => (/* binding */ useAddCart)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../utils/constants */ "./src/ts/utils/constants.ts");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils/type.helper */ "./src/ts/utils/type.helper.ts");
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! uuid */ "./node_modules/uuid/dist/esm-browser/v4.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! axios */ "./node_modules/axios/index.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _useLocalStorage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./useLocalStorage */ "./src/ts/hooks/useLocalStorage.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../utils/TEXT */ "./src/ts/utils/TEXT.ts");











var useAddCart = function useAddCart() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_5__.ProductContext),
    dispatch = _useContext.productDispatch,
    state = _useContext.productState;
  var lsPreviewData = (0,_useLocalStorage__WEBPACK_IMPORTED_MODULE_8__.useLocalStorage)(_utils_constants__WEBPACK_IMPORTED_MODULE_4__.TOWEL_LOCAL_STORAGE_PRODUCT_PREVIEW_DATA);
  var handleAddCartSubmit = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function () {
    // !REMOVE BEFORE PUBLISH

    var handleSubmittingLeave = function handleSubmittingLeave(e) {
      e.returnValue = 'submitting';
    };
    window.addEventListener('beforeunload', handleSubmittingLeave);
    dispatch({
      type: _utils_constants__WEBPACK_IMPORTED_MODULE_4__.ProductPage.TOGGLE_SUBMITTING
    });
    var validateResult = true;
    (function validateCUSTOMIZE() {
      switch (state.customize.showType) {
        case _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.ONLY_MOTIF:
          {
            validateResult = !state.customize.characterText && !!state.customize.motifId;
            if (!validateResult) {
              dispatch({
                type: _utils_constants__WEBPACK_IMPORTED_MODULE_4__.ProductPage.CHANGE_ERROR_MESSAGE,
                errorMessage: _utils_TEXT__WEBPACK_IMPORTED_MODULE_9__["default"].PRODUCT.ERROR.ONLY_MOTIF
              });
            }
            break;
          }
        case _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.ONLY_CHAR:
          {
            validateResult = !!state.customize.characterText && !state.customize.motifId;
            if (!validateResult) {
              dispatch({
                type: _utils_constants__WEBPACK_IMPORTED_MODULE_4__.ProductPage.CHANGE_ERROR_MESSAGE,
                errorMessage: _utils_TEXT__WEBPACK_IMPORTED_MODULE_9__["default"].PRODUCT.ERROR.ONLY_CHAR
              });
            }
            break;
          }
        case _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.BOTH:
          {
            validateResult = !!state.customize.characterText && !!state.customize.motifId;
            if (!validateResult) {
              if (!state.customize.characterText && !state.customize.motifId) {
                dispatch({
                  type: _utils_constants__WEBPACK_IMPORTED_MODULE_4__.ProductPage.CHANGE_ERROR_MESSAGE,
                  errorMessage: _utils_TEXT__WEBPACK_IMPORTED_MODULE_9__["default"].PRODUCT.ERROR.NORMAL
                });
              } else if (!state.customize.characterText) {
                dispatch({
                  type: _utils_constants__WEBPACK_IMPORTED_MODULE_4__.ProductPage.CHANGE_ERROR_MESSAGE,
                  errorMessage: _utils_TEXT__WEBPACK_IMPORTED_MODULE_9__["default"].PRODUCT.ERROR.ONLY_CHAR
                });
              } else if (!state.customize.motifId) {
                dispatch({
                  type: _utils_constants__WEBPACK_IMPORTED_MODULE_4__.ProductPage.CHANGE_ERROR_MESSAGE,
                  errorMessage: _utils_TEXT__WEBPACK_IMPORTED_MODULE_9__["default"].PRODUCT.ERROR.ONLY_MOTIF
                });
              }
            }
            break;
          }
        default:
          break;
      }
    })();
    if (validateResult) {
      dispatch({
        type: _utils_constants__WEBPACK_IMPORTED_MODULE_4__.ProductPage.CHANGE_ERROR_MESSAGE,
        errorMessage: ''
      });
    } else {
      dispatch({
        type: _utils_constants__WEBPACK_IMPORTED_MODULE_4__.ProductPage.TOGGLE_SUBMITTING
      });
      window.removeEventListener('beforeunload', handleSubmittingLeave);
      return;
    }
    if (!state.panelOpen) {
      dispatch({
        type: _utils_constants__WEBPACK_IMPORTED_MODULE_4__.ProductPage.EMPTY_ALL_CUSTOMIZE,
        isInit: false
      });
    }
    var fn = /*#__PURE__*/function () {
      var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee3() {
        var _uuidForTowel, _previewDiv$querySele, _previewDiv$querySele2, _previewDiv$querySele3, _previewDiv$querySele4, previewDiv, bgHeight, imageWidth, fontSize, _currentVariant, _customize, newData, index, _yield$axios$get, dataInCart, items, addTowelProduct, addCharProduct, addMotifProduct;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _uuidForTowel = state._uuidForTowel || (0,uuid__WEBPACK_IMPORTED_MODULE_10__["default"])(); // save preview data
              if (state.customize.showType !== _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.HIDE && document.getElementById('motif-preview')) {
                previewDiv = document.getElementById('motif-preview');
                bgHeight = previewDiv.offsetHeight;
                imageWidth = previewDiv.querySelector('img') ? (_previewDiv$querySele = (_previewDiv$querySele2 = previewDiv.querySelector('img')) === null || _previewDiv$querySele2 === void 0 ? void 0 : _previewDiv$querySele2.width) !== null && _previewDiv$querySele !== void 0 ? _previewDiv$querySele : 200 : 200;
                fontSize = previewDiv.querySelector('span') ? (_previewDiv$querySele3 = (_previewDiv$querySele4 = previewDiv.querySelector('span')) === null || _previewDiv$querySele4 === void 0 ? void 0 : _previewDiv$querySele4.style.fontSize.replace('px', '')) !== null && _previewDiv$querySele3 !== void 0 ? _previewDiv$querySele3 : '30' : '30';
                _currentVariant = state.currentVariant;
                _customize = state.customize;
                newData = '';
                if (lsPreviewData) {
                  if (lsPreviewData.findIndex(function (item) {
                    return item.uuid === _uuidForTowel;
                  }) >= 0) {
                    // if existed then exchange value
                    index = lsPreviewData.findIndex(function (item) {
                      return item.uuid === _uuidForTowel;
                    });
                    lsPreviewData[index].fontSize = Number(fontSize);
                    lsPreviewData[index].imageWidth = imageWidth;
                    lsPreviewData[index].bgHeight = bgHeight;
                    lsPreviewData[index]._currentVariant = _currentVariant;
                    lsPreviewData[index]._customize = _customize;
                    newData = JSON.stringify(lsPreviewData);
                  } else {
                    // if first time simply add to end
                    newData = JSON.stringify([].concat((0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__["default"])(lsPreviewData), [{
                      uuid: _uuidForTowel,
                      imageWidth: imageWidth,
                      fontSize: fontSize,
                      bgHeight: bgHeight,
                      _currentVariant: _currentVariant,
                      _customize: _customize
                    }]));
                  }
                } else {
                  // no data exist create a new one
                  newData = JSON.stringify([{
                    uuid: _uuidForTowel,
                    imageWidth: imageWidth,
                    fontSize: fontSize,
                    bgHeight: bgHeight,
                    _currentVariant: _currentVariant,
                    _customize: _customize
                  }]);
                }
                localStorage.setItem(_utils_constants__WEBPACK_IMPORTED_MODULE_4__.TOWEL_LOCAL_STORAGE_PRODUCT_PREVIEW_DATA, newData);
              }
              _context3.prev = 2;
              _context3.next = 5;
              return axios__WEBPACK_IMPORTED_MODULE_7___default().get('/cart.json');
            case 5:
              _yield$axios$get = _context3.sent;
              dataInCart = _yield$axios$get.data;
              items = dataInCart.items.filter(function (item) {
                return item.properties._uuidForTowel !== _uuidForTowel;
              }).map(function (_ref2) {
                var id = _ref2.id,
                  quantity = _ref2.quantity,
                  properties = _ref2.properties;
                return {
                  id: id,
                  quantity: quantity,
                  properties: properties
                };
              });
              addTowelProduct = function addTowelProduct(lineItems, showType) {
                if (showType === _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.HIDE) {
                  lineItems.push({
                    id: state.currentVariant.variantId.toString(),
                    quantity: state.currentVariant.quantity,
                    properties: {
                      _level: 2,
                      _uuidForTowel: _uuidForTowel,
                      _type: _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ProductType.TOWEL,
                      _isGiftbox: state.preview.isGiftbox,
                      _isWrapping: state.preview.isWrapping
                    }
                  });
                } else {
                  var _mark_code = [_utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.ONLY_MOTIF, _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.BOTH].includes(showType) ? state.customize.motifIchihiroId : '';
                  var _mark_name = [_utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.ONLY_MOTIF, _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.BOTH].includes(showType) ? state.customize.motifName : '';
                  var _shishu_text = [_utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.ONLY_CHAR, _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.BOTH].includes(showType) ? state.customize.characterText : '';
                  var _shishu_layout = showType === _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.BOTH ? state.customize.motifLayout : '';
                  var _character_name = [_utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.ONLY_CHAR, _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.BOTH].includes(showType) ? state.customize.characterName : '';
                  var _character_color = [_utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.ONLY_CHAR, _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.BOTH].includes(showType) ? state.customize.characterColor : '';
                  var _character_size = [_utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.ONLY_CHAR, _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.BOTH].includes(showType) ? state.customize.characterSize : '';
                  lineItems.push({
                    id: state.currentVariant.variantId.toString(),
                    quantity: state.currentVariant.quantity,
                    properties: {
                      _level: 2,
                      _uuidForTowel: _uuidForTowel,
                      _type: _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ProductType.TOWEL,
                      _mark_code: _mark_code,
                      _mark_name: _mark_name,
                      _shishu_text: _shishu_text,
                      _shishu_pos: state.customize.position,
                      _shishu_layout: _shishu_layout,
                      _character_name: _character_name,
                      _character_color: _character_color,
                      _character_size: _character_size,
                      _isGiftbox: state.preview.isGiftbox,
                      _isWrapping: state.preview.isWrapping,
                      刺繍テキスト: state.customize.characterText,
                      モチーフの名前: state.customize.motifName,
                      刺繍位置: state.customize.position
                    }
                  });
                }
              };
              addCharProduct = /*#__PURE__*/function () {
                var _ref3 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee(lineItems) {
                  var characterId;
                  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return getCharVariantId(state.customize);
                      case 2:
                        characterId = _context.sent;
                        lineItems.push({
                          id: characterId,
                          quantity: state.currentVariant.quantity * state.customize.characterText.replace(/\s+/g, '').length,
                          properties: {
                            _level: 3,
                            _uuidForTowel: _uuidForTowel,
                            _type: _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ProductType.CHAR,
                            _shishu_text: state.customize.characterText,
                            刺繍テキスト: state.customize.characterText
                          }
                        });
                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function addCharProduct(_x) {
                  return _ref3.apply(this, arguments);
                };
              }();
              addMotifProduct = /*#__PURE__*/function () {
                var _ref4 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee2(lineItems) {
                  var motifId;
                  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return getMotifVariantId(state.customize);
                      case 2:
                        motifId = _context2.sent;
                        lineItems.push({
                          id: motifId,
                          quantity: state.currentVariant.quantity,
                          properties: {
                            _level: 3,
                            _mark_code: state.customize.motifIchihiroId,
                            _uuidForTowel: _uuidForTowel,
                            _type: _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ProductType.MOTIF,
                            モチーフの名前: state.customize.motifName
                          }
                        });
                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function addMotifProduct(_x2) {
                  return _ref4.apply(this, arguments);
                };
              }();
              addTowelProduct(items, state.customize.showType);
              _context3.t0 = state.customize.showType;
              _context3.next = _context3.t0 === _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.ONLY_CHAR ? 15 : _context3.t0 === _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.ONLY_MOTIF ? 18 : _context3.t0 === _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.ShowType.BOTH ? 21 : 26;
              break;
            case 15:
              _context3.next = 17;
              return addCharProduct(items);
            case 17:
              return _context3.abrupt("break", 26);
            case 18:
              _context3.next = 20;
              return addMotifProduct(items);
            case 20:
              return _context3.abrupt("break", 26);
            case 21:
              _context3.next = 23;
              return addMotifProduct(items);
            case 23:
              _context3.next = 25;
              return addCharProduct(items);
            case 25:
              return _context3.abrupt("break", 26);
            case 26:
              _context3.next = 28;
              return axios__WEBPACK_IMPORTED_MODULE_7___default().post('/cart/clear.js');
            case 28:
              _context3.next = 30;
              return axios__WEBPACK_IMPORTED_MODULE_7___default().post('/cart/add.js', {
                items: items
              });
            case 30:
              window.removeEventListener('beforeunload', handleSubmittingLeave);
              location.href = '/cart';
              _context3.next = 40;
              break;
            case 34:
              _context3.prev = 34;
              _context3.t1 = _context3["catch"](2);
              /* eslint no-console: ["error", { allow: ["warn", "error"] }] */
              console.error({
                error: _context3.t1
              });
              // if (
              //   error.response &&
              //   error.response.data &&
              //   error.response.data.description
              // ) {
              //   if (error.response.data.description.includes('これ以上')) {
              //     dispatch({
              //       type: ProductPage.CHANGE_ERROR_MESSAGE,
              //       errorMessage: '商品の在庫がご希望の数量より不足しております。'
              //     });
              //   } else {
              //     dispatch({
              //       type: ProductPage.CHANGE_ERROR_MESSAGE,
              //       errorMessage: error.response.data.description
              //     });
              //   }
              // } else {
              dispatch({
                type: _utils_constants__WEBPACK_IMPORTED_MODULE_4__.ProductPage.CHANGE_ERROR_MESSAGE,
                errorMessage: 'エラーが発生しました。しばらく時間をおいてから再度お試しください。'
              });
              // }

              window.removeEventListener('beforeunload', handleSubmittingLeave);
              dispatch({
                type: _utils_constants__WEBPACK_IMPORTED_MODULE_4__.ProductPage.TOGGLE_SUBMITTING
              });
            case 40:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2, 34]]);
      }));
      return function fn() {
        return _ref.apply(this, arguments);
      };
    }();
    fn();
  }, [state, dispatch, lsPreviewData]);
  return handleAddCartSubmit;
};
var getMotifVariantId = /*#__PURE__*/function () {
  var _ref5 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee4(customize) {
    var _yield$axios$get2, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return axios__WEBPACK_IMPORTED_MODULE_7___default().get("/products/".concat(_utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.motifHandles[customize.motifShopifyId ? customize.motifShopifyId : 6208882376853], ".json"));
        case 2:
          _yield$axios$get2 = _context4.sent;
          data = _yield$axios$get2.data;
          return _context4.abrupt("return", data.product.variants.find(function (variant) {
            var _customize$motifLayou;
            return variant.title === ((_customize$motifLayou = customize.motifLayout) !== null && _customize$motifLayou !== void 0 ? _customize$motifLayou : 'おまかせ');
          }).id);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getMotifVariantId(_x3) {
    return _ref5.apply(this, arguments);
  };
}();
var getCharVariantId = /*#__PURE__*/function () {
  var _ref6 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee5(customize) {
    var _yield$axios$get3, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return axios__WEBPACK_IMPORTED_MODULE_7___default().get("/products/".concat(_utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.charHandles[customize.characterId ? customize.characterId : 6270116069525], ".json"));
        case 2:
          _yield$axios$get3 = _context5.sent;
          data = _yield$axios$get3.data;
          return _context5.abrupt("return", data.product.variants.find(function (variant) {
            return variant.title === customize.characterSize + ' / ' + customize.characterColor;
          }).id);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getCharVariantId(_x4) {
    return _ref6.apply(this, arguments);
  };
}();

/***/ }),

/***/ "./src/ts/hooks/useCartAssetGet.tsx":
/*!******************************************!*\
  !*** ./src/ts/hooks/useCartAssetGet.tsx ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useCartAssetGet": () => (/* binding */ useCartAssetGet)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_type_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils/type.helper */ "./src/ts/utils/type.helper.ts");


var useCartAssetGet = function useCartAssetGet(type) {
  return ['font-medium leading-loose text-white lg:w-4/5 lg:mx-auto text-sm lg:text-base', "1.".concat(type, "\u30C7\u30B6\u30A4\u30F3\u3092\u304A\u9078\u3073\u304F\u3060\u3055\u3044"), 'grid grid-cols-2 gap-1 lg:grid-cols-3', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "my-3"
  }, "2.".concat(type, "\u5185\u5BB9\u3092\u3054\u8A18\u8F09\u304F\u3060\u3055\u3044")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", null, "(1\u884C", _utils_type_helper__WEBPACK_IMPORTED_MODULE_1__.CHART_LIMIT_IN_GIFT, "\u6587\u5B57)"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", null, "\u203B\u7D75\u6587\u5B57\u3001\u8A18\u53F7\u7B49\u306F\u6587\u5B57\u5316\u3051\u306B\u306A\u308A\u307E\u3059\u3002"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", null, "\u6587\u5B57\u306E\u307F\u3092\u3054\u5165\u529B\u9802\u304D\u307E\u3059\u3088\u3046\u304A\u9858\u3044\u7533\u3057\u4E0A\u3052\u307E\u3059\u3002"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "my-3 text-xs font-normal lg:text-sm"
  }, type == 'メッセージカード' ? "\u7121\u8A18\u5165\u306E".concat(type, "\u3092\u3054\u5E0C\u671B\u306E\u304A\u5BA2\u69D8\u306F\u3001\u300C\u7121\u5730\u5E0C\u671B\u300D\u3068\u8A18\u5165\u306E\u4E0A\u300C\u6C7A\u5B9A\u300D\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002") : "\u7121\u8A18\u540D\u306E".concat(type, "\u30FB\u30EA\u30DC\u30F3\u3092\u3054\u5E0C\u671B\u306E\u304A\u5BA2\u69D8\u306F\u3001\u3053\u306E\u307E\u307E\u8A18\u5165\u305B\u305A\u306B\u300C\u6C7A\u5B9A\u300D\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002")))];
};

/***/ }),

/***/ "./src/ts/hooks/useChangeCustomizeValue.tsx":
/*!**************************************************!*\
  !*** ./src/ts/hooks/useChangeCustomizeValue.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useChangeCustomizeValue": () => (/* binding */ useChangeCustomizeValue)
/* harmony export */ });
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/constants */ "./src/ts/utils/constants.ts");

var useChangeCustomizeValue = function useChangeCustomizeValue(dispatch) {
  var change = function change(field, value) {
    dispatch({
      type: _utils_constants__WEBPACK_IMPORTED_MODULE_0__.ProductPage.CUSTOMIZE_OPTION_CHANGE,
      field: field,
      value: value
    });
  };
  return change;
};

/***/ }),

/***/ "./src/ts/hooks/useCharText.tsx":
/*!**************************************!*\
  !*** ./src/ts/hooks/useCharText.tsx ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useCharText": () => (/* binding */ useCharText)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/TEXT */ "./src/ts/utils/TEXT.ts");
/* harmony import */ var _useChangeCustomizeValue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./useChangeCustomizeValue */ "./src/ts/hooks/useChangeCustomizeValue.tsx");
/* harmony import */ var _useKanaConverter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./useKanaConverter */ "./src/ts/hooks/useKanaConverter.tsx");






var useCharText = function useCharText() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__.ProductContext),
    state = _useContext.productState,
    dispatch = _useContext.productDispatch;
  var changeCustomizeValue = (0,_useChangeCustomizeValue__WEBPACK_IMPORTED_MODULE_4__.useChangeCustomizeValue)(dispatch);
  var _useKanaConverter = (0,_useKanaConverter__WEBPACK_IMPORTED_MODULE_5__.useKanaConverter)(),
    kataToHira = _useKanaConverter.kataToHira,
    hiraTokata = _useKanaConverter.hiraTokata;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(state.customize.characterText),
    _useState2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(text.length),
    _useState4 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState3, 2),
    currentCount = _useState4[0],
    setCurrentCount = _useState4[1];
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
    _useState6 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState5, 2),
    errorMsg = _useState6[0],
    setErrorMsg = _useState6[1];
  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(state.customize.characterFont),
    _useState8 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState7, 2),
    previousFont = _useState8[0],
    setPreviousFont = _useState8[1];
  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function () {
      return state.customize.characterFont === 'font-kosugi' || state.customize.characterFont === 'font-noto' ? 'JA' : 'EN';
    }),
    _useState10 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState9, 2),
    lang = _useState10[0],
    setLang = _useState10[1];
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (previousFont !== state.customize.characterFont) {
      setPreviousFont(state.customize.characterFont);
      setText(state.customize.characterText);
    }
    setLang(state.customize.characterFont === 'font-kosugi' || state.customize.characterFont === 'font-noto' ? 'JA' : 'EN');
    setCurrentCount(state.customize.characterText.length);
  }, [state.customize, previousFont, changeCustomizeValue]);
  var handleTextChange = function handleTextChange(e) {
    var input = e.target.value;
    var selectedFont = state.customize.characterFont;
    var english = new RegExp(/^[a-zA-Z0-9\s\.]*$/g);
    var japanese = new RegExp(/^[ぁ-んァ-ン|\s|ー]*[a-zA-Zａ-ｚ]{0,2}$/g);
    var hiragana = new RegExp(/^[ぁ-ん|\s|ー]*[a-zA-Zａ-ｚ]{0,2}$/g);
    var katakana = new RegExp(/^[ァ-ン|\s|ー]*[a-zA-Zａ-ｚ]{0,2}$/g);
    var newGlobalText = '';
    var newLocalText = '';
    if (lang === 'EN') {
      if (state.preview.eNumber >= input.length) {
        if (english.test(input)) {
          newGlobalText = newLocalText = input;
        } else {
          newGlobalText = input.replace(/[^\w]+/g, '');
          newLocalText = input;
        }
      } else {
        newGlobalText = newLocalText = state.customize.characterText;
      }
    } else if (lang === 'JA') {
      if (state.preview.jNumber >= input.length) {
        if (japanese.test(input)) {
          // hiragana
          if (selectedFont === 'font-kosugi') {
            // convert local only when fire onCompositionEnd
            newGlobalText = kataToHira(input).replace(/[a-zA-Zａ-ｚ]+/g, '');
            newLocalText = input;
            // katakana
          } else {
            newGlobalText = hiraTokata(input).replace(/[a-zA-Zａ-ｚ]+/g, '');
            newLocalText = input;
          }
        } else {
          // when typing get chinese char
          newLocalText = input.replace(/[\w]+/g, '');
          newGlobalText = input.replace(/[\w一-龥ａ-ｚ\W]+/g, '');
        }
      } else {
        if (selectedFont === 'font-kosugi') {
          // convert local only when fire onCompositionEnd
          newGlobalText = kataToHira(input).slice(0, state.preview.jNumber).replace(/[a-zA-Zａ-ｚ]+/g, '');
          newLocalText = input.slice(0, state.preview.jNumber);
          // katakana
        } else {
          newGlobalText = hiraTokata(input).slice(0, state.preview.jNumber).replace(/[a-zA-Zａ-ｚ]+/g, '');
          newLocalText = input.slice(0, state.preview.jNumber);
        }
      }
    } else {
      newGlobalText = newLocalText = state.customize.characterText;
    }
    // handle error message
    if (selectedFont === 'font-kosugi') {
      // hira
      if (hiragana.test(newLocalText)) {
        setErrorMsg('');
      } else {
        setErrorMsg(_utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.ERROR.TEXT_ONLY_HIRA);
      }
    } else if (selectedFont === 'font-noto') {
      // kata
      if (katakana.test(newLocalText)) {
        setErrorMsg('');
      } else {
        setErrorMsg(_utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.ERROR.TEXT_ONLY_KATA);
      }
    } else {
      // english
      english.lastIndex = 0;
      if (english.test(newLocalText)) {
        setErrorMsg('');
      } else {
        setErrorMsg(_utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.ERROR.TEXT_ONLY_ALPH);
      }
    }

    // error message

    changeCustomizeValue('characterText', newGlobalText);
    setText(newLocalText);
    setCurrentCount(newGlobalText.length);
  };
  var totalCount = lang === 'EN' ? state.preview.eNumber : state.preview.jNumber;
  var handleCompositionEnd = function handleCompositionEnd() {
    var selectedFont = state.customize.characterFont;
    var hiragana = new RegExp(/^[ぁ-ん|\s|ー]*$/g);
    var katakana = new RegExp(/^[ァ-ン|\s|ー]*$/g);
    if (selectedFont === 'font-kosugi') {
      setText(function (input) {
        var finalText = kataToHira(input);
        if (hiragana.test(finalText)) {
          setErrorMsg('');
        } else {
          setErrorMsg(_utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.ERROR.TEXT_ONLY_HIRA);
        }
        return finalText;
      });
    } else if (selectedFont === 'font-noto') {
      setText(function (input) {
        var finalText = hiraTokata(input);
        if (katakana.test(finalText)) {
          setErrorMsg('');
        } else {
          setErrorMsg(_utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.ERROR.TEXT_ONLY_KATA);
        }
        return finalText;
      });
    }
  };
  var handleCompositionStart = function handleCompositionStart() {
    if (lang === 'EN') {
      setErrorMsg(_utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.ERROR.TEXT_ONLY_ALPH);
    } else {
      setErrorMsg('');
    }
  };
  var handleFocus = function handleFocus() {
    setTimeout(function () {
      window.initalKeyBoard = false;
    }, 500);
  };
  return {
    text: text,
    currentCount: currentCount,
    totalCount: totalCount,
    handleTextChange: handleTextChange,
    handleCompositionEnd: handleCompositionEnd,
    handleCompositionStart: handleCompositionStart,
    handleFocus: handleFocus,
    errorMsg: errorMsg,
    color: state.customize.characterCode
  };
};

/***/ }),

/***/ "./src/ts/hooks/useDebounce.tsx":
/*!**************************************!*\
  !*** ./src/ts/hooks/useDebounce.tsx ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useDebounce": () => (/* binding */ useDebounce)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");


var useDebounce = function useDebounce(value) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState(value),
    _React$useState2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_React$useState, 2),
    debouncedValue = _React$useState2[0],
    setDebouncedValue = _React$useState2[1];
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay);

    // Cancel the timeout if value changes (also on delay change or unmount)
    return function () {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};

/***/ }),

/***/ "./src/ts/hooks/useFontColor.tsx":
/*!***************************************!*\
  !*** ./src/ts/hooks/useFontColor.tsx ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useFontColor": () => (/* binding */ useFontColor)
/* harmony export */ });
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");


var useFontColor = function useFontColor() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_0__.ProductContext),
    state = _useContext.productState;
  var color = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var bgColor = state.currentVariant.color;
    var selectedFontCOlor = state.customize.characterCode;
    if (state.customize.characterCode === '#222') {
      var c = bgColor.substring(1); // strip #
      var rgb = parseInt(c, 16); // convert rrggbb to decimal
      var r = rgb >> 16 & 0xff; // extract red
      var g = rgb >> 8 & 0xff; // extract green
      var b = rgb >> 0 & 0xff; // extract blue

      var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

      return luma < 40 ? '#fff' : selectedFontCOlor;
    } else {
      return state.customize.characterCode;
    }
  }, [state]);
  return color;
};

/***/ }),

/***/ "./src/ts/hooks/useGetProductDOMValue.tsx":
/*!************************************************!*\
  !*** ./src/ts/hooks/useGetProductDOMValue.tsx ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useGetProductDOMValue": () => (/* binding */ useGetProductDOMValue)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils/constants */ "./src/ts/utils/constants.ts");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _useQuerySelectorJson__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./useQuerySelectorJson */ "./src/ts/hooks/useQuerySelectorJson.tsx");




var useGetProductDOMValue = function useGetProductDOMValue() {
  var tmpProduct = (0,_useQuerySelectorJson__WEBPACK_IMPORTED_MODULE_3__.useQuerySelectorJson)('#t-product-shopify');
  var tmpPreview = (0,_useQuerySelectorJson__WEBPACK_IMPORTED_MODULE_3__.useQuerySelectorJson)('#t-product-preview');
  var html1 = (0,_useQuerySelectorJson__WEBPACK_IMPORTED_MODULE_3__.useQuerySelectorJson)('#t-product-html1');
  var html2 = (0,_useQuerySelectorJson__WEBPACK_IMPORTED_MODULE_3__.useQuerySelectorJson)('#t-product-html2');
  var tmpColors = (0,_useQuerySelectorJson__WEBPACK_IMPORTED_MODULE_3__.useQuerySelectorJson)('#t-product-colors');
  var colors = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(tmpColors);
  var product = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(tmpProduct);
  var preview = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(tmpPreview);
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__.ProductContext),
    dispatch = _useContext.productDispatch;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    dispatch({
      type: _utils_constants__WEBPACK_IMPORTED_MODULE_1__.ProductPage.INIT_PRODUCT_PAGE,
      product: product.current,
      color: colors.current ? colors.current[0] : '',
      preview: preview.current
    });
  }, [dispatch, colors, product, preview]);
  return {
    html1: html1,
    html2: html2,
    colors: colors.current,
    product: product.current,
    preview: preview.current
  };
};

/***/ }),

/***/ "./src/ts/hooks/useIsMobile.tsx":
/*!**************************************!*\
  !*** ./src/ts/hooks/useIsMobile.tsx ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useIsMobile": () => (/* binding */ useIsMobile)
/* harmony export */ });
var useIsMobile = function useIsMobile() {
  return window.innerWidth <= 1024;
};

/***/ }),

/***/ "./src/ts/hooks/useKanaConverter.tsx":
/*!*******************************************!*\
  !*** ./src/ts/hooks/useKanaConverter.tsx ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useKanaConverter": () => (/* binding */ useKanaConverter)
/* harmony export */ });
var useKanaConverter = function useKanaConverter() {
  var kataToHira = function kataToHira(str) {
    return Array.from(str).map(function (letter) {
      return letter.replace(/[\u30a1-\u30f6]/g, function (match) {
        return String.fromCharCode(match.charCodeAt(0) - 0x60);
      });
    }).join('');
  };
  var hiraTokata = function hiraTokata(str) {
    return Array.from(str).map(function (letter) {
      return letter.replace(/[\u3041-\u3096]/g, function (match) {
        return String.fromCharCode(match.charCodeAt(0) + 0x60);
      });
    }).join('');
  };
  return {
    kataToHira: kataToHira,
    hiraTokata: hiraTokata
  };
};

/***/ }),

/***/ "./src/ts/hooks/useLanguage.tsx":
/*!**************************************!*\
  !*** ./src/ts/hooks/useLanguage.tsx ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useLanguage": () => (/* binding */ useLanguage)
/* harmony export */ });
var useLanguage = function useLanguage() {
  return function (font) {
    var result;
    if (['font-kosugi', 'font-noto'].includes(font)) {
      result = 'JA';
    } else if (['font-lato', 'font-pinyon', 'font-hobo'].includes(font)) {
      result = 'EN';
    } else {
      result = 'EN';
    }
    return result;
  };
};

/***/ }),

/***/ "./src/ts/hooks/useLineLimitAndChange.tsx":
/*!************************************************!*\
  !*** ./src/ts/hooks/useLineLimitAndChange.tsx ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useLineLimitAndChange": () => (/* binding */ useLineLimitAndChange)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils/constants */ "./src/ts/utils/constants.ts");
/* harmony import */ var _utils_contexts_CartContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/contexts/CartContext */ "./src/ts/utils/contexts/CartContext.tsx");



var useLineLimitAndChange = function useLineLimitAndChange() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_CartContext__WEBPACK_IMPORTED_MODULE_2__.CartContext),
    dispatch = _useContext.cartDispatch;
  return function (charLimit, inputValue, index, field) {
    // TODO: adjust line limit
    var lines = inputValue.split('\n');
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].length < charLimit) {
        continue;
      }
      var j = 0;
      var space = charLimit;
      while (j++ <= charLimit) {
        if (lines[i].charAt(j) === ' ') {
          space = j;
        }
      }
      lines[i + 1] = lines[i].substring(space + 1) + (lines[i + 1] || '');
      lines[i] = lines[i].substring(0, space);
    }
    var result = lines.slice(0, 5).join('\n');
    dispatch({
      type: _utils_constants__WEBPACK_IMPORTED_MODULE_1__.CartPage.CHANGE_GIFT,
      index: index,
      field: field,
      value: result
    });
  };
};

/***/ }),

/***/ "./src/ts/hooks/useLocalStorage.tsx":
/*!******************************************!*\
  !*** ./src/ts/hooks/useLocalStorage.tsx ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useLocalStorage": () => (/* binding */ useLocalStorage)
/* harmony export */ });
var useLocalStorage = function useLocalStorage(key) {
  var item = localStorage.getItem(key);
  if (!item) return null;
  return JSON.parse(item);
};

/***/ }),

/***/ "./src/ts/hooks/useMoney.tsx":
/*!***********************************!*\
  !*** ./src/ts/hooks/useMoney.tsx ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useMoney": () => (/* binding */ useMoney)
/* harmony export */ });
var useMoney = function useMoney(withTax) {
  var numberWithComma = function numberWithComma(x) {
    var parts = x.toString().replace(/00$/, '').split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  };
  var formatter = function formatter(price) {
    return '{{amount_no_decimals}}円(税込み)'.replace('{{amount_no_decimals}}', numberWithComma(price.toString()));
  };
  return withTax ? numberWithComma : formatter;
};

/***/ }),

/***/ "./src/ts/hooks/useMotifCategoriesQuery.tsx":
/*!**************************************************!*\
  !*** ./src/ts/hooks/useMotifCategoriesQuery.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useMotifCategoriesQuery": () => (/* binding */ useMotifCategoriesQuery)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-query */ "./node_modules/react-query/es/index.js");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/helpers */ "./src/ts/utils/helpers.ts");




var getCategories = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(limit, motifParentCategory, disabledMotifCategory) {
    var disableString, params, _yield$MotifAxios$get, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          disableString = disabledMotifCategory ? disabledMotifCategory.map(function (category) {
            return '[and]id[not_equals]' + category;
          }).join('') : '';
          params = {
            fields: 'id,name,image',
            limit: limit,
            orders: 'rank',
            filters: "parentCategory[contains]".concat(motifParentCategory).concat(disableString)
          };
          _context.next = 4;
          return _utils_helpers__WEBPACK_IMPORTED_MODULE_3__.MotifAxios.get('/categories', {
            params: params
          });
        case 4:
          _yield$MotifAxios$get = _context.sent;
          data = _yield$MotifAxios$get.data;
          return _context.abrupt("return", data.contents);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getCategories(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var useMotifCategoriesQuery = function useMotifCategoriesQuery(limit, motifParentCategory, disabledMotifCategory) {
  return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)(['categories', limit, motifParentCategory, disabledMotifCategory], function () {
    return getCategories(limit, motifParentCategory, disabledMotifCategory);
  }, {
    refetchOnMount: false,
    enabled: !!motifParentCategory
  });
};

/***/ }),

/***/ "./src/ts/hooks/useMotifsQuery.tsx":
/*!*****************************************!*\
  !*** ./src/ts/hooks/useMotifsQuery.tsx ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useMotifsQuery": () => (/* binding */ useMotifsQuery)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-query */ "./node_modules/react-query/es/index.js");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/helpers */ "./src/ts/utils/helpers.ts");




var getMotifs = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(category, limit, motifParentCategory) {
    var params, _yield$MotifAxios$get, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          params = {
            filters: "category[equals]".concat(category, "[and]parentCategoryId[contains]").concat(motifParentCategory, "[and]shouldHide[equals]false"),
            fields: 'id,name,photo,illustration',
            limit: limit
          };
          _context.next = 3;
          return _utils_helpers__WEBPACK_IMPORTED_MODULE_3__.MotifAxios.get('/icons', {
            params: params
          });
        case 3:
          _yield$MotifAxios$get = _context.sent;
          data = _yield$MotifAxios$get.data;
          return _context.abrupt("return", {
            motifs: data.contents,
            total: data.totalCount
          });
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getMotifs(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var useMotifsQuery = function useMotifsQuery(category, limit, enabled, motifParentCategory) {
  return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)(['motifs', category, limit, motifParentCategory], function () {
    return getMotifs(category, limit, motifParentCategory);
  }, {
    refetchOnMount: false,
    enabled: enabled
  });
};

/***/ }),

/***/ "./src/ts/hooks/useProductDivData.tsx":
/*!********************************************!*\
  !*** ./src/ts/hooks/useProductDivData.tsx ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useProductDivData": () => (/* binding */ useProductDivData)
/* harmony export */ });
var useProductDivData = function useProductDivData() {
  var _ref = document.querySelector('#t-ts-product-detail').dataset,
    url = _ref.url,
    id = _ref.id,
    title = _ref.title,
    price = _ref.price,
    type = _ref.type,
    featured_image = _ref.featured_image,
    handle = _ref.handle;
  var typedType = type;
  return {
    url: url,
    id: id,
    title: title,
    price: price,
    type: typedType,
    featured_image: featured_image,
    handle: handle
  };
};

/***/ }),

/***/ "./src/ts/hooks/useProductSliders.tsx":
/*!********************************************!*\
  !*** ./src/ts/hooks/useProductSliders.tsx ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useProductSliders": () => (/* binding */ useProductSliders)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");


var useProductSliders = function useProductSliders() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
      nav1: undefined,
      nav2: undefined
    }),
    _useState2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState, 2),
    sliderStates = _useState2[0],
    setSliderStates = _useState2[1];
  var slider1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(undefined);
  var slider2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(undefined);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setSliderStates({
      nav1: slider1.current,
      nav2: slider2.current
    });
  }, []);
  var nav1 = sliderStates.nav1,
    nav2 = sliderStates.nav2;
  return {
    nav1: nav1,
    nav2: nav2,
    slider1: slider1,
    slider2: slider2
  };
};

/***/ }),

/***/ "./src/ts/hooks/useQuerySelectorJson.tsx":
/*!***********************************************!*\
  !*** ./src/ts/hooks/useQuerySelectorJson.tsx ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useQuerySelectorJson": () => (/* binding */ useQuerySelectorJson)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var useQuerySelectorJson = function useQuerySelectorJson(selector) {
  var rawJson = document.querySelector(selector);
  var result = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return JSON.parse(rawJson.innerHTML);
  }, [rawJson]);
  return result;
};

/***/ }),

/***/ "./src/ts/hooks/useSelectVariant.tsx":
/*!*******************************************!*\
  !*** ./src/ts/hooks/useSelectVariant.tsx ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useSelectVariant": () => (/* binding */ useSelectVariant)
/* harmony export */ });
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/constants */ "./src/ts/utils/constants.ts");

var useSelectVariant = function useSelectVariant() {
  return function (slider, index, productDispatch, state, color) {
    /** image order adjust */
    slider === null || slider === void 0 ? void 0 : slider.slickGoTo(index + 1);
    // slider?.slickGoTo(index); // no need

    productDispatch({
      type: _utils_constants__WEBPACK_IMPORTED_MODULE_0__.ProductPage.CHANGE_VARIANT,
      variant: {
        index: index,
        color: color,
        variantId: state.product.variants[index].id,
        sku: state.product.variants[index].sku,
        title: state.product.variants[index].title,
        price: state.product.variants[index].price,
        compare_at_price: state.product.variants[index].compare_at_price,
        available: state.product.variants[index].available
      }
    });
  };
};

/***/ }),

/***/ "./src/ts/hooks/useSubmitCheckout.tsx":
/*!********************************************!*\
  !*** ./src/ts/hooks/useSubmitCheckout.tsx ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useSubmitCheckout": () => (/* binding */ useSubmitCheckout)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! axios */ "./node_modules/axios/index.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils/constants */ "./src/ts/utils/constants.ts");
/* harmony import */ var _utils_contexts_CartContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils/contexts/CartContext */ "./src/ts/utils/contexts/CartContext.tsx");
/* harmony import */ var _utils_type_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/type.helper */ "./src/ts/utils/type.helper.ts");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! date-fns */ "./node_modules/date-fns/esm/addBusinessDays/index.js");



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var useSubmitCheckout = function useSubmitCheckout(setSubmitting) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(_utils_contexts_CartContext__WEBPACK_IMPORTED_MODULE_6__.CartContext),
    state = _useContext.cartState,
    dispatch = _useContext.cartDispatch;
  return (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function () {
    var formatLineItems = function formatLineItems() {
      setSubmitting(true);
      var lineItems = [];
      var itemCountWithGift = 0;
      if (state.gifts.length) {
        //! giftが選択された場合
        state.gifts.forEach(function (gift) {
          var _gift$_uuidForGift, _gift$noshiType, _gift$noshiText, _gift$messageCardType, _gift$message;
          //! giftをlineitemに入れる
          var giftItem = {
            id: gift.id,
            quantity: 1,
            properties: {
              _level: 1,
              _uuidForGift: (_gift$_uuidForGift = gift._uuidForGift) !== null && _gift$_uuidForGift !== void 0 ? _gift$_uuidForGift : '',
              _type: gift.type,
              のしタイプ: (_gift$noshiType = gift.noshiType) !== null && _gift$noshiType !== void 0 ? _gift$noshiType : '',
              のし文字: (_gift$noshiText = gift.noshiText) !== null && _gift$noshiText !== void 0 ? _gift$noshiText : '',
              メッセージカードタイプ: (_gift$messageCardType = gift.messageCardType) !== null && _gift$messageCardType !== void 0 ? _gift$messageCardType : '',
              メッセージ: (_gift$message = gift.message) !== null && _gift$message !== void 0 ? _gift$message : ''
            }
          };
          lineItems.push(giftItem);

          //! giftに紐づく商品をlineitemに入れる
          state.items.forEach(function (item) {
            if (item._uuidForGift && item._uuidForGift === gift._uuidForGift) {
              var newFlg = true;
              for (var i = 0; i < lineItems.length; i++) {
                if (item.id !== lineItems[i].id || item._uuidForGift !== lineItems[i].properties._uuidForGift) {
                  continue;
                }
                if (item.properties._mark_code !== lineItems[i].properties._mark_code) {
                  continue;
                }
                if (item.properties._shishu_text !== lineItems[i].properties._shishu_text) {
                  continue;
                }
                if (item.properties._shishu_pos !== lineItems[i].properties._shishu_pos) {
                  continue;
                }
                if (item.properties._character_name !== lineItems[i].properties._character_name) {
                  continue;
                }
                if (item.properties._character_color !== lineItems[i].properties._character_color) {
                  continue;
                }
                if (item.properties._character_size !== lineItems[i].properties._character_size) {
                  continue;
                }
                lineItems[i].quantity = lineItems[i].quantity + 1;
                newFlg = false;
                break;
              }
              if (newFlg) {
                var towelItem = {
                  id: item.id,
                  quantity: 1,
                  properties: _objectSpread(_objectSpread({}, item.properties), {}, {
                    _uuidForGift: item._uuidForGift
                  })
                };
                lineItems.push(towelItem);
              }
              itemCountWithGift = itemCountWithGift + 1;
            }
          });
        });

        //! giftと紐づく商品が存在しない場合
        if (state.items.length > 0 && itemCountWithGift === 0) {
          return [];
        }

        //! giftに紐づかない商品をlineitemに入れる
        state.items.forEach(function (item) {
          var newFlg = true;
          if (!item._uuidForGift) {
            for (var i = 0; i < lineItems.length; i++) {
              if (item.id !== lineItems[i].id || lineItems[i].properties._uuidForGift) {
                continue;
              }
              if (item.properties._mark_code !== lineItems[i].properties._mark_code) {
                continue;
              }
              if (item.properties._shishu_text !== lineItems[i].properties._shishu_text) {
                continue;
              }
              if (item.properties._shishu_pos !== lineItems[i].properties._shishu_pos) {
                continue;
              }
              if (item.properties._character_name !== lineItems[i].properties._character_name) {
                continue;
              }
              if (item.properties._character_color !== lineItems[i].properties._character_color) {
                continue;
              }
              if (item.properties._character_size !== lineItems[i].properties._character_size) {
                continue;
              }
              lineItems[i].quantity = lineItems[i].quantity + 1;
              newFlg = false;
              break;
            }
            if (newFlg) {
              var towelItem = {
                id: item.id,
                quantity: 1,
                properties: item.properties
              };
              lineItems.push(towelItem);
            }
          }
        });

        //! 刺繍をlineitemに入れる
        state.embros.forEach(function (embro) {
          var embroItem = {
            id: embro.id,
            quantity: embro.quantity,
            properties: embro.properties
          };
          lineItems.push(embroItem);
        });
      } else {
        //! giftがない場合
        //! 商品をlineitemに入れる
        state.towels.forEach(function (towel) {
          var towelItem = {
            id: towel.id,
            quantity: towel.quantity,
            properties: towel.properties
          };
          lineItems.push(towelItem);
        });

        //! 刺繍をlineitemに入れる
        state.embros.forEach(function (embro) {
          var embroItem = {
            id: embro.id,
            quantity: embro.quantity,
            properties: embro.properties
          };
          lineItems.push(embroItem);
        });
      }
      // check if need add pickup product
      if (document.querySelector('.storepickup-pickup-tab.active')) {
        var pickupProduct = {
          id: _utils_constants__WEBPACK_IMPORTED_MODULE_5__.PICKUP_PRODUCT_VARIANT_ID,
          quantity: 1,
          properties: {
            _type: _utils_type_helper__WEBPACK_IMPORTED_MODULE_7__.ProductType.PICKUP
          }
        };
        lineItems.push(pickupProduct);
      }
      return lineItems;
    };
    var handleFormSubmitWithApp = function handleFormSubmitWithApp() {
      var _document$querySelect, _document$querySelect2;
      var form = document.querySelector('#t-checkout');
      var tDatePicker = (_document$querySelect = document.querySelector('input.DatePicker__input')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value;
      var tTimePicker = (_document$querySelect2 = document.querySelector('#date-picker-time')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.value;
      form.querySelector('[name="attributes[Checkout-Method]"').value = state.attributes['Checkout-Method'] || '';
      form.querySelector('[name="attributes[Pickup-Date]"').value = tDatePicker;
      form.querySelector('[name="attributes[Pickup-Time]"').value = tTimePicker === '希望なし' ? '' : tTimePicker;
      var submitButton = form.querySelector('input[type="submit"]');
      submitButton === null || submitButton === void 0 ? void 0 : submitButton.click();
      // form.submit();
    };

    var checkDeliveryDelayDays = function checkDeliveryDelayDays() {
      var _ref2, _document$querySelect3;
      var towelDatePicker = document.getElementById('js-date-picker');
      var towelDateInput = towelDatePicker.querySelector('input');
      var deliveryMethod = document.getElementById('storepickup-methods');
      var deliveryActiveMethod = deliveryMethod.querySelector('li.active');
      if (towelDateInput.value === undefined || towelDateInput.value === null || towelDateInput.value === '') {
        return true;
      }
      var _ref = (_ref2 = JSON.parse(document.querySelector('#t-cart-extra-data') ? (_document$querySelect3 = document.querySelector('#t-cart-extra-data')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.innerHTML : 'null')) !== null && _ref2 !== void 0 ? _ref2 : {
          deliveryDays: 14,
          deliveryDaysWithshishu: 14,
          receiptDays: 14,
          receiptDaysWithshishu: 14
        },
        deliveryDays = _ref.deliveryDays,
        deliveryDaysWithshishu = _ref.deliveryDaysWithshishu,
        receiptDays = _ref.receiptDays,
        receiptDaysWithshishu = _ref.receiptDaysWithshishu;
      var deliveryRefDays = state.embros.length > 0 ? deliveryDaysWithshishu : deliveryDays;
      var receiptRefDays = state.embros.length > 0 ? receiptDaysWithshishu : receiptDays;
      var today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      var target = new Date(towelDateInput.value);
      target.setHours(0);
      target.setMinutes(0);
      target.setSeconds(1);
      if (deliveryActiveMethod.className.indexOf('storepickup-shipping-tab') !== -1) {
        today = (0,date_fns__WEBPACK_IMPORTED_MODULE_8__["default"])(today, deliveryRefDays);
      } else if (deliveryActiveMethod.className.indexOf('storepickup-pickup-tab') !== -1) {
        today = (0,date_fns__WEBPACK_IMPORTED_MODULE_8__["default"])(today, receiptRefDays);
      } else {
        return false;
      }
      if (today < target) {
        return true;
      }
      return false;
    };
    var fn = /*#__PURE__*/function () {
      var _ref3 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee() {
        var lineItems;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              lineItems = formatLineItems();
              _context.prev = 1;
              if (!(lineItems.length === 0)) {
                _context.next = 4;
                break;
              }
              throw new Error('ギフトの設定でエラーが発生しました。恐れ入りますが一度戻るボタンを押してギフト設定のやり直しをお願いします。');
            case 4:
              if (checkDeliveryDelayDays()) {
                _context.next = 6;
                break;
              }
              throw new Error('配送日時の指定が正しくありません。');
            case 6:
              _context.next = 8;
              return axios__WEBPACK_IMPORTED_MODULE_3___default().post('/cart/clear.js');
            case 8:
              _context.next = 10;
              return axios__WEBPACK_IMPORTED_MODULE_3___default().post('/cart/add.js', {
                items: lineItems,
                note: state.note
              });
            case 10:
              handleFormSubmitWithApp();
              _context.next = 18;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](1);
              console.error({
                error: _context.t0
              });
              setSubmitting(false);
              dispatch({
                type: _utils_constants__WEBPACK_IMPORTED_MODULE_5__.CartPage.CHANGE_ERROR_MESSAGE,
                errorMessage: _context.t0.message ? _context.t0.message : 'エラーが発生しました。しばらく時間をおいてから再度お試しください。'
              });
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 13]]);
      }));
      return function fn() {
        return _ref3.apply(this, arguments);
      };
    }();
    fn();
  }, [state, dispatch, setSubmitting]);
};

/***/ }),

/***/ "./src/ts/utils/TEXT.ts":
/*!******************************!*\
  !*** ./src/ts/utils/TEXT.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  COMMON: {
    EMBRO: '刺繍サービス',
    GIFTBOX: 'ギフトボックス可',
    WRAPPING: 'ラッピング可',
    RECENTLY: '閲覧履歴',
    SHOPPING: 'ショッピングを続ける',
    MORE: 'もっと見る',
    HIDE: '閉じる'
  },
  PRODUCT: {
    TOP: {
      PRODUCT_DETAIL: '商品詳細',
      OPTION_SERVICE: 'オプションサービス',
      SERVICE_DETAIL: '刺繍サービスの詳細',
      PRODUCT_INFO: '商品情報',
      COLOR_QUAN: 'カラー・数量',
      ADD_CART: 'カートに入れる',
      NO_STOCK: '在庫切れ',
      NO_CUSTOMIZE: '刺繍しない',
      CUSTOMIZE: '刺繍する'
    },
    CUSTOMIZE: {
      TITLE: '刺繍設定',
      SHOW_TYPE: '刺繍の種類を選択',
      CHAR_FONT: 'フォントを選択',
      CHAR_COLOR: '刺繍のカラーを選択',
      CHAR_TEXT: '刺繍テキストを入力',
      CHAR_SIZE: '1文字のサイズを選択',
      CHAR_TEXT_WARNING: 'ご注意)キャラクターのイニシャル及び名称を刺繍することはできません。予めご了承ください。',
      MOTIF_SELECT: 'モチーフを選択',
      MOTIF_LAYOUT: '刺繍レイアウトを選択',
      MOTIF_POSITION: '刺繍位置を選択',
      PREVIEW_IMAGE: 'プレビュー',
      PREVIEW_POSITION: '位置プレビュー',
      PREVIEW_WARNING_1: ' ※プレビューはイメージです。',
      PREVIEW_WARNING_2: '実際の仕上がりとは異なる場合がございます。',
      PREVIEW_WARNING_3: 'モチーフのサイズは変わりません。',
      WARNING: '「おまかせ」はデザインに合わせ適切な位置に刺繍いたします。',
      ALERT_PREVIEW_1: '※刺繍位置が正しく表示されない場合は',
      ALERT_PREVIEW_2: 'こちら',
      ALERT_PREVIEW_3: 'を押してください。'
    },
    MOTIF: {
      PLACEHOLDER: '例)ミッキーマウス',
      TITLE: 'モチーフキーワード検索',
      SEARCH: '検索',
      NO: '該当するモチーフはありません',
      NO_MOTIF_TEXT1: '申し訳ございません',
      NO_MOTIF_TEXT2: 'ただ今準備中です。'
    },
    ERROR: {
      ONLY_MOTIF: 'モチーフを入れてください。',
      ONLY_CHAR: '刺繍文字を入れてください。',
      NORMAL: '刺繍文字とモチーフを入れてください。',
      TEXT_ONLY_ALPH: '半角英数字のみでお願いします。',
      TEXT_ONLY_HIRA: 'ひらがなのみでお願いします。',
      TEXT_ONLY_KATA: 'カタカナのみでお願いします。'
    }
  },
  CART: {
    COMMON: {
      EMBRO: '刺繍',
      MOTIF: 'モチーフ',
      NO_EMBRO: '刺繍サービスなし',
      DELIVERY: '配送の日時指定をする',
      SUBMIT: '購入手続きに進む',
      GIFTBOX: 'ギフトボックス(275円/個)',
      WRAPPING: 'ラッピング袋(77円/枚)',
      PRODUCT_PRICE: '商品合計(送料別)',
      GIFT_PRICE: 'ギフト合計(送料別)',
      TOTAL_PRICE: '合計(送料別)',
      CLEAR: 'カートをクリア',
      NOTE: '備考',
      NOTE_PLACEHOLDER: 'その他ご要望があればこちらにご記入ください。\n例:領収書希望\n(ご希望が無い限り、納品書、領収書はお入れしていません。)',
      DATE_SHIPPING: '配送希望日時',
      DATE_PICKUP: '店舗受取希望日',
      ANNOUNCEMENT_NO_ITEM: '5500円以上で送料無料',
      ANNOUNCEMENT_MORE_ITEM1: 'あと',
      ANNOUNCEMENT_MORE_ITEM2: '円で送料無料',
      ANNOUNCEMENT_OVER_ITEM: '現在 送料無料'
    },
    EMPTY: {
      TITLE: 'ショッピングカート',
      STATUS: '現在カート内に商品はございません。',
      SHOPPING: 'ショッピングを続ける'
    },
    FIRST: {
      TITLE: 'ご注文商品',
      EDIT: '刺繍を編集する',
      PREVIEW: '刺繍をプレビューする',
      EMBRO_PRICE: '刺繍価格',
      TOWEL_PRICE: '本体価格',
      GIFT_SETTING: 'オプション設定：ギフトラッピング',
      GIFT_SETTING_DESCRIPTION: 'ラッピングの種類を選んで＋を押して決定してください。',
      GIFT: 'ギフト',
      ABOUT_GIFT: 'ギフト・ラッピングについて',
      SELECT: '選択してください',
      NO_NEED: '不要',
      EMBRO_PREVIEW: '刺繍プレビュー',
      ADD_GIFT_BTN: '決定',
      TO_GIFT_SETTING: '次へ進む',
      GUIDE: '＋を押す度、カートに追加されます。（必要な個数分押してください。）'
    },
    SECOND: {
      TITLE_1: 'ギフト設定',
      TITLE_2: '一緒にラッピングする商品を選択してください。',
      SELECT: '選択',
      SELECTED: '選択済',
      UNSELECT: '再設定',
      UNSELECTABLE: 'ギフト設定不可',
      SET_GIFT: '選択した商品のギフトを設定',
      ADD_GIFTCARD: 'カード・熨斗・リボンを設定する',
      CANCEL_MODAL_ALL: '設定した商品を全て解除します。',
      CANCEL_MODAL_OK: 'よろしいですか',
      CANCEL_BTN_LEFT: 'はい',
      CANCEL_BTN_RIGHT: 'いいえ',
      ADD_MODAL_TITLE: 'ギフト種別を選択してください',
      ADD_BTN_LEFT: '戻る',
      ADD_BTN_RIGHT: '決定',
      CONFIRM_RETURN: 'ギフト追加画面に戻ると、ギフトの設定がなくなります！！よろしいですか？'
    },
    THIRD: {
      TITLE_1: 'メッセージカード・熨斗の設定',
      TITLE_2: 'メッセージカード・熨斗をご希望の方はギフトごとに設定してください。\n※熨斗は「ギフトボックス」に限り設定可能です。',
      CARD_DESIGN: 'カードデザイン',
      CARD_CONTENT: 'メッセージカード内容',
      NOSHI_DESIGN: '熨斗デザイン',
      NOSHI_CONTENT: '熨斗内容',
      EDIT: '編集',
      ADD: '追加',
      CARD: 'メッセージカードを',
      NOSHI: '熨斗・リボンを',
      DO: 'する'
    }
  }
});

/***/ }),

/***/ "./src/ts/utils/cartActions.ts":
/*!*************************************!*\
  !*** ./src/ts/utils/cartActions.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "deleteAll": () => (/* binding */ deleteAll)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! axios */ "./node_modules/axios/index.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./constants */ "./src/ts/utils/constants.ts");




var deleteAll = function deleteAll() {
  localStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_3__.TOWEL_LOCAL_STORAGE_PRODUCT_PREVIEW_DATA);
  var fn = /*#__PURE__*/function () {
    var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return axios__WEBPACK_IMPORTED_MODULE_2___default().post('/cart/clear.js');
          case 3:
            _context.next = 5;
            return axios__WEBPACK_IMPORTED_MODULE_2___default().post('/cart/update.js', {
              attributes: {
                'Checkout-Method': null,
                'Delivery-Location-Id': null,
                'Pickup-Date': null,
                'Pickup-Time': null,
                'Pickup-Location-Id': null,
                'Pickup-Location-Company': null,
                'Pickup-Location-Address-Line-1': null,
                'Pickup-Location-City': null,
                'Pickup-Location-Region': null,
                'Pickup-Location-Postal-Code': null,
                'Pickup-Location-Country': null
              }
            });
          case 5:
            location.reload();
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
            console.error({
              error: _context.t0
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function fn() {
      return _ref.apply(this, arguments);
    };
  }();
  fn();
};

/***/ }),

/***/ "./src/ts/utils/constants.ts":
/*!***********************************!*\
  !*** ./src/ts/utils/constants.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BASE_ASSET_URL": () => (/* binding */ BASE_ASSET_URL),
/* harmony export */   "CartPage": () => (/* binding */ CartPage),
/* harmony export */   "NO_IMAGE_PLACEHOLDER": () => (/* binding */ NO_IMAGE_PLACEHOLDER),
/* harmony export */   "PICKUP_PRODUCT_VARIANT_ID": () => (/* binding */ PICKUP_PRODUCT_VARIANT_ID),
/* harmony export */   "PREVIEW_POSITION_HEIGHT": () => (/* binding */ PREVIEW_POSITION_HEIGHT),
/* harmony export */   "ProductPage": () => (/* binding */ ProductPage),
/* harmony export */   "TOWEL_LOCAL_STORAGE_PANEL_OPEN": () => (/* binding */ TOWEL_LOCAL_STORAGE_PANEL_OPEN),
/* harmony export */   "TOWEL_LOCAL_STORAGE_PRODUCT_CUSTOMIZE_DATA": () => (/* binding */ TOWEL_LOCAL_STORAGE_PRODUCT_CUSTOMIZE_DATA),
/* harmony export */   "TOWEL_LOCAL_STORAGE_PRODUCT_PREVIEW_DATA": () => (/* binding */ TOWEL_LOCAL_STORAGE_PRODUCT_PREVIEW_DATA),
/* harmony export */   "TOWEL_LOCAL_STORAGE_VIEWED_PRODUCTS": () => (/* binding */ TOWEL_LOCAL_STORAGE_VIEWED_PRODUCTS)
/* harmony export */ });
var TOWEL_LOCAL_STORAGE_VIEWED_PRODUCTS = 'TOWEL_LOCAL_STORAGE_VIEWED_PRODUCTS';
var TOWEL_LOCAL_STORAGE_PANEL_OPEN = 'TOWEL_LOCAL_STORAGE_PANEL_OPEN';
var TOWEL_LOCAL_STORAGE_PRODUCT_PREVIEW_DATA = 'TOWEL_LOCAL_STORAGE_PRODUCT_PREVIEW_DATA';
var TOWEL_LOCAL_STORAGE_PRODUCT_CUSTOMIZE_DATA = 'TOWEL_LOCAL_STORAGE_PRODUCT_CUSTOMIZE_DATA';
var PREVIEW_POSITION_HEIGHT = 640;
var ProductPage = /*#__PURE__*/function (ProductPage) {
  ProductPage["CHANGE_VARIANT"] = "CHANGE_VARIANT";
  ProductPage["INIT_PRODUCT_PAGE"] = "INIT_PRODUCT_PAGE";
  ProductPage["TOGGLE_SUBMITTING"] = "TOGGLE_SUBMITTING";
  ProductPage["TOGGLE_PANEL"] = "TOGGLE_PANEL";
  ProductPage["SUBMIT_ADD_CART"] = "SUBMIT_ADD_CART";
  ProductPage["CUSTOMIZE_OPTION_CHANGE"] = "CUSTOMIZE_OPTION_CHANGE";
  ProductPage["EMPTY_ALL_CUSTOMIZE"] = "EMPTY_ALL_CUSTOMIZE";
  ProductPage["FETCH_ONE_MOTIF"] = "FETCH_ONE_MOTIF";
  ProductPage["CHANGE_ERROR_MESSAGE"] = "CHANGE_ERROR_MESSAGE";
  return ProductPage;
}({});
var CartPage = /*#__PURE__*/function (CartPage) {
  CartPage["UPDATE_ITEMS"] = "UPDATE_ITEMS";
  CartPage["UPDATE_ATTRIBUTES"] = "UPDATE_ATTRIBUTES";
  CartPage["GET_ITEMS"] = "GET_ITEMS";
  CartPage["ADD_GIFT"] = "ADD_GIFT";
  CartPage["CHANGE_GIFT"] = "CHANGE_GIFT";
  CartPage["CHANGE_ITEM"] = "CHANGE_ITEM";
  CartPage["SUBMIT_TO_CHECKOUT"] = "SUBMIT_TO_CHECKOUT";
  CartPage["CHANGE_STEP"] = "CHANGE_STEP";
  CartPage["CHANGE_QUANTITY"] = "CHANGE_QUANTITY";
  CartPage["DELETE_TOWEL"] = "DELETE_TOWEL";
  CartPage["DECIDE_GIFT"] = "DECIDE_GIFT";
  CartPage["DELETE_GIFT"] = "DELETE_GIFT";
  CartPage["RESET_GIFT"] = "RESET_GIFT";
  CartPage["CHANGE_NOTE"] = "CHANGE_NOTE";
  CartPage["CHANGE_ERROR_MESSAGE"] = "CHANGE_ERROR_MESSAGE";
  return CartPage;
}({});
var BASE_ASSET_URL = window.Towel.assetBaseUrl;
var NO_IMAGE_PLACEHOLDER = 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
var PICKUP_PRODUCT_VARIANT_ID = '40374457630869';

/***/ }),

/***/ "./src/ts/utils/contexts/CartContext.tsx":
/*!***********************************************!*\
  !*** ./src/ts/utils/contexts/CartContext.tsx ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CartContext": () => (/* binding */ CartContext),
/* harmony export */   "CartProvider": () => (/* binding */ CartProvider)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _type_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../type.helper */ "./src/ts/utils/type.helper.ts");
/* harmony import */ var _CartReducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CartReducer */ "./src/ts/utils/contexts/CartReducer.tsx");





var cartStateValue = {
  step: _type_helper__WEBPACK_IMPORTED_MODULE_2__.CartStepEnum.ADD_GIFT,
  errorMessage: '',
  price: '',
  items: [],
  gifts: [],
  embros: [],
  towels: [],
  note: '',
  attributes: {}
};
var CartContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  cartState: cartStateValue,
  cartDispatch: function cartDispatch() {
    return null;
  }
});
CartContext.displayName = 'CartContext';
var CartProvider = function CartProvider(_ref) {
  var children = _ref.children;
  var _useReducer = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(_CartReducer__WEBPACK_IMPORTED_MODULE_3__.cartReducer, cartStateValue),
    _useReducer2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useReducer, 2),
    cartState = _useReducer2[0],
    cartDispatch = _useReducer2[1];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(CartContext.Provider, {
    value: {
      cartState: cartState,
      cartDispatch: cartDispatch
    }
  }, children);
};

/***/ }),

/***/ "./src/ts/utils/contexts/CartReducer.tsx":
/*!***********************************************!*\
  !*** ./src/ts/utils/contexts/CartReducer.tsx ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cartReducer": () => (/* binding */ cartReducer)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../constants */ "./src/ts/utils/constants.ts");
/* harmony import */ var _type_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../type.helper */ "./src/ts/utils/type.helper.ts");
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! uuid */ "./node_modules/uuid/dist/esm-browser/v4.js");


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var cartReducer = function cartReducer(state, actions) {
  switch (actions.type) {
    case _constants__WEBPACK_IMPORTED_MODULE_2__.CartPage.UPDATE_ITEMS:
      {
        var _towels = actions.items.filter(function (towel) {
          var _towel$properties;
          return ((_towel$properties = towel.properties) === null || _towel$properties === void 0 ? void 0 : _towel$properties._level) === 2;
        });
        var _embros = actions.items.filter(function (item) {
          var _item$properties;
          return ((_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : _item$properties._level) === 3;
        });
        var _gifts = actions.items.filter(function (item) {
          var _item$properties2;
          return ((_item$properties2 = item.properties) === null || _item$properties2 === void 0 ? void 0 : _item$properties2._level) === 1;
        }).map(function (item) {
          var _item$properties$メッセー;
          var gift = {
            id: +item.id,
            _uuidForGift: item.properties._uuidForGift,
            type: item.properties._type,
            status: 2,
            messageCardType: (_item$properties$メッセー = item.properties.メッセージカードタイプ) !== null && _item$properties$メッセー !== void 0 ? _item$properties$メッセー : null,
            message: item.properties.メッセージ,
            noshiType: item.properties.のしタイプ,
            noshiText: item.properties.のし文字
          };
          return gift;
        });
        var step = _gifts.length ? _type_helper__WEBPACK_IMPORTED_MODULE_3__.CartStepEnum.ASSIGN_GIFT : _type_helper__WEBPACK_IMPORTED_MODULE_3__.CartStepEnum.ADD_GIFT;
        var items = [];
        if (step === _type_helper__WEBPACK_IMPORTED_MODULE_3__.CartStepEnum.ASSIGN_GIFT) {
          _towels.forEach(function (item) {
            for (var i = 0; i < item.quantity; i++) {
              var _item$properties$_uui;
              items.push(_objectSpread(_objectSpread({}, item), {}, {
                status: item.properties._uuidForGift ? _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.CONFIRMED : _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.UNSELECT,
                _uuidForGift: (_item$properties$_uui = item.properties._uuidForGift) !== null && _item$properties$_uui !== void 0 ? _item$properties$_uui : ''
              }));
            }
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          embros: _embros,
          towels: _towels,
          gifts: _gifts,
          step: step,
          items: items,
          attributes: actions.attributes
        });
      }
    case _constants__WEBPACK_IMPORTED_MODULE_2__.CartPage.UPDATE_ATTRIBUTES:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          attributes: actions.attributes
        });
      }
    case _constants__WEBPACK_IMPORTED_MODULE_2__.CartPage.GET_ITEMS:
      {
        var _items = [];
        actions.towels.forEach(function (towel) {
          for (var i = 0; i < towel.quantity; i++) {
            _items.push(_objectSpread(_objectSpread({}, towel), {}, {
              status: 0
            }));
          }
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          items: _items
        });
      }
    case _constants__WEBPACK_IMPORTED_MODULE_2__.CartPage.CHANGE_NOTE:
      return _objectSpread(_objectSpread({}, state), {}, {
        note: actions.note
      });
    case _constants__WEBPACK_IMPORTED_MODULE_2__.CartPage.ADD_GIFT:
      var id = _type_helper__WEBPACK_IMPORTED_MODULE_3__.ShopifyGift[actions.giftType];
      return _objectSpread(_objectSpread({}, state), {}, {
        gifts: [].concat((0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__["default"])(state.gifts), [{
          id: id,
          type: actions.giftType,
          status: _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.UNSELECT
        }])
      });
    case _constants__WEBPACK_IMPORTED_MODULE_2__.CartPage.CHANGE_GIFT:
      var gifts = JSON.parse(JSON.stringify(state.gifts));
      gifts[actions.index][actions.field] = actions.value;
      return _objectSpread(_objectSpread({}, state), {}, {
        gifts: gifts
      });
    case _constants__WEBPACK_IMPORTED_MODULE_2__.CartPage.CHANGE_ITEM:
      {
        var _actions$value;
        var _items2 = JSON.parse(JSON.stringify(state.items));
        _items2[actions.index][actions.field] = (_actions$value = actions.value) !== null && _actions$value !== void 0 ? _actions$value : '';
        return _objectSpread(_objectSpread({}, state), {}, {
          items: _items2
        });
      }
    case _constants__WEBPACK_IMPORTED_MODULE_2__.CartPage.SUBMIT_TO_CHECKOUT:
      return state;
    case _constants__WEBPACK_IMPORTED_MODULE_2__.CartPage.CHANGE_STEP:
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      return _objectSpread(_objectSpread({}, state), {}, {
        step: actions.step
      });
    case _constants__WEBPACK_IMPORTED_MODULE_2__.CartPage.DELETE_TOWEL:
      {
        var _towels2 = JSON.parse(JSON.stringify(state.towels));
        _towels2.splice(actions.index, 1);
        return _objectSpread(_objectSpread({}, state), {}, {
          towels: _towels2
        });
      }
    case _constants__WEBPACK_IMPORTED_MODULE_2__.CartPage.CHANGE_QUANTITY:
      var towels = JSON.parse(JSON.stringify(state.towels));
      towels[actions.index]['quantity'] = actions.quantity;
      var uuid = state.towels[actions.index].properties._uuidForTowel;
      var embros = state.embros.map(function (embro) {
        if (embro.properties._uuidForTowel === uuid) {
          if (embro.properties._type === 'character') {
            var characterNumber = embro.properties._shishu_text.replace(/\s+/g, '').length;
            return _objectSpread(_objectSpread({}, embro), {}, {
              quantity: characterNumber * actions.quantity
            });
          } else {
            return _objectSpread(_objectSpread({}, embro), {}, {
              quantity: actions.quantity
            });
          }
        } else {
          return embro;
        }
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        towels: towels,
        embros: embros
      });
    case _constants__WEBPACK_IMPORTED_MODULE_2__.CartPage.DECIDE_GIFT:
      {
        var _gifts2 = [];
        var _items3 = [];
        if (actions.ok) {
          var _uuidForGift = (0,uuid__WEBPACK_IMPORTED_MODULE_4__["default"])();
          _gifts2 = state.gifts.map(function (gift) {
            return gift.status === _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.SELECTED ? _objectSpread(_objectSpread({}, gift), {}, {
              status: _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.CONFIRMED,
              _uuidForGift: _uuidForGift
            }) : gift;
          });
          _items3 = state.items.map(function (item) {
            return item.status === _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.SELECTED ? _objectSpread(_objectSpread({}, item), {}, {
              status: _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.CONFIRMED,
              _uuidForGift: _uuidForGift
            }) : item;
          });
        } else {
          _gifts2 = state.gifts.map(function (gift) {
            return gift.status === _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.SELECTED ? _objectSpread(_objectSpread({}, gift), {}, {
              status: _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.UNSELECT
            }) : gift;
          });
          _items3 = state.items.map(function (item) {
            return item.status === _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.SELECTED ? _objectSpread(_objectSpread({}, item), {}, {
              status: _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.UNSELECT
            }) : item;
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          gifts: _gifts2,
          items: _items3
        });
      }
    case _constants__WEBPACK_IMPORTED_MODULE_2__.CartPage.RESET_GIFT:
      {
        var _gifts3 = [];
        var _items4 = [];
        var _towels3 = [];
        if (actions.step === _type_helper__WEBPACK_IMPORTED_MODULE_3__.CartStepEnum.ASSIGN_GIFT) {
          _gifts3 = state.gifts.map(function (_ref) {
            var id = _ref.id,
              type = _ref.type;
            return {
              id: id,
              type: type,
              status: _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.UNSELECT
            };
          });
        } else {
          _gifts3 = state.gifts.map(function (gift) {
            return gift.status === _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.CONFIRMED ? _objectSpread(_objectSpread({}, gift), {}, {
              status: _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.UNSELECT,
              _uuidForGift: ''
            }) : gift;
          });
          _items4 = state.items.map(function (item) {
            return item.status === _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.CONFIRMED ? _objectSpread(_objectSpread({}, item), {}, {
              status: _type_helper__WEBPACK_IMPORTED_MODULE_3__.ItemStatus.UNSELECT,
              _uuidForGift: ''
            }) : item;
          });
        }
        state.towels.forEach(function (towel) {
          delete towel.properties._uuidForGift;
          _towels3.push(_objectSpread({}, towel));
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          gifts: _gifts3,
          items: _items4,
          towels: _towels3
        });
      }
    case _constants__WEBPACK_IMPORTED_MODULE_2__.CartPage.DELETE_GIFT:
      {
        var _gifts4 = state.gifts.filter(function (gift, giftIndex) {
          return giftIndex !== actions.index;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          gifts: _gifts4
        });
      }
    case _constants__WEBPACK_IMPORTED_MODULE_2__.CartPage.CHANGE_ERROR_MESSAGE:
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      return _objectSpread(_objectSpread({}, state), {}, {
        errorMessage: actions.errorMessage
      });
    default:
      return state;
  }
};

/***/ }),

/***/ "./src/ts/utils/contexts/PreviewRatio.ts":
/*!***********************************************!*\
  !*** ./src/ts/utils/contexts/PreviewRatio.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "COMMON_RATIO": () => (/* binding */ COMMON_RATIO),
/* harmony export */   "RATIO": () => (/* binding */ RATIO)
/* harmony export */ });
var COMMON_RATIO = {
  Preview: 0.048,
  // use for preview not position preview
  DefaultFontSize: 1.5,
  // default user font size
  Mobile: {
    is: 0.8,
    not: 1
  },
  // mobile font/motif adjust
  Lang: {
    EN: 1,
    JA: 0.8
  },
  // language font/motif adjust
  Loop: {
    Mobile: 4,
    Desktop: 6
  },
  // loop preview move ratio
  MotifFont: 2.5 // calculate motif size based on font size
};

var RATIO = {
  BT: {
    font: 2,
    verticalBg: {
      width: 0.0303,
      height: 0.0325
    },
    horizontalBg: {
      width: 0.0303,
      height: 0.0125
    }
  },
  FT: {
    // フェイスタオル tmoc-72-0042100
    font: 1.5,
    verticalBg: {
      width: 0.0403,
      height: 0.0325
    },
    horizontalBg: {
      width: 0.0303,
      height: 0.05
    }
  },
  WT: {
    // ウォッシュタオル tmoc-72-0041060
    font: 1.5,
    verticalBg: {
      width: 0.0303,
      height: 0.0525
    },
    horizontalBg: {
      width: 0.0303,
      height: 0.0125
    }
  },
  MHT: {
    // ミニタオル tmoc-72-0040050
    font: 1.5,
    verticalBg: {
      width: 0.0403,
      height: 0.0325
    },
    horizontalBg: {
      width: 0.0303,
      height: 0.0125
    }
  },
  MT: {
    // マイクロタオル wp-25-2020040
    font: 0.7,
    verticalBg: {
      width: 0.0703,
      height: 0.0525
    },
    horizontalBg: {
      width: 0.0303,
      height: 0.0125
    }
  },
  HMT: {
    // ハーフミニタオル tmoc-72-2000050
    font: 1,
    verticalBg: {
      width: 0.0603,
      height: 0.0395
    },
    horizontalBg: {
      width: 0.0303,
      height: 0.0125
    }
  },
  MFT: {
    // マフラータオル ad-06-1295100
    font: 1.5,
    verticalBg: {
      width: 0.0903,
      height: 0.0525
    },
    horizontalBg: {
      width: 0.0203,
      height: 0.0925
    }
  },
  ST: {
    // スポーツタオル ad-06-1295150
    font: 1.7,
    verticalBg: {
      width: 0.0303,
      height: 0.0225
    },
    horizontalBg: {
      width: 0.0203,
      height: 0.0325
    }
  },
  MLT: {
    // マルチタオル ttl-22-1380100
    font: 3.5,
    verticalBg: {
      width: 0.0353,
      height: 0.0525
    },
    horizontalBg: {
      width: 0.0303,
      height: 0.0125
    }
  },
  KT: {
    // ブランケット wp-25-2227120
    font: 1.5,
    verticalBg: {
      width: 0.0303,
      height: 0.0125
    },
    horizontalBg: {
      width: 0.0303,
      height: 0.0125
    }
  }
};

/***/ }),

/***/ "./src/ts/utils/contexts/PreviewReducer.tsx":
/*!**************************************************!*\
  !*** ./src/ts/utils/contexts/PreviewReducer.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "previewInitState": () => (/* binding */ previewInitState),
/* harmony export */   "previewReducer": () => (/* binding */ previewReducer)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var _PreviewRatio__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./PreviewRatio */ "./src/ts/utils/contexts/PreviewRatio.ts");


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var previewInitState = {
  meta: {
    type: '',
    isMobile: false
  },
  charAndMotif: {
    lang: 'EN',
    selectedFontSize: 2,
    fontSize: 0,
    motifShowSize: 0,
    motifSizeRatio: 2,
    towelWidth: 0,
    eNumber: 0,
    jNumber: 0
  },
  bg: {
    verticalImageUrl: '',
    horizontalImageUrl: '',
    currentDirection: 'vertical',
    possiblePositions: ['vertical'],
    isSpecialShape: false,
    isSquareShape: false
  },
  position: {
    topBottom: 'center',
    leftRightLoop: 'center',
    leaningLying: 'leaning',
    lyingUndefined: undefined,
    leaningTransform: '',
    artLeft: '',
    artTop: '',
    artRight: '',
    artBottom: '',
    transform: ''
  },
  ratio: _PreviewRatio__WEBPACK_IMPORTED_MODULE_2__.RATIO,
  commonRatio: _PreviewRatio__WEBPACK_IMPORTED_MODULE_2__.COMMON_RATIO
};
var previewReducer = function previewReducer(state, action) {
  var type = state.meta.type ? state.meta.type : 'BT';
  var lang = state.charAndMotif.lang;
  var isMobile = state.meta.isMobile ? 'Mobile' : 'Desktop';
  switch (action.type) {
    case 'assign_preview':
      var _action$payload = action.payload,
        commonRatio = _action$payload.commonRatio,
        ratio = _action$payload.ratio,
        meta = _action$payload.meta,
        bg = _action$payload.bg,
        position = _action$payload.position,
        charAndMotif = _action$payload.charAndMotif;
      return {
        meta: meta,
        bg: bg,
        position: position,
        charAndMotif: charAndMotif,
        ratio: ratio,
        commonRatio: commonRatio
      };
    case 'change_font':
      {
        var getFontMotifSize = function getFontMotifSize() {
          var adjustByLangAndMobile = function adjustByLangAndMobile(num) {
            var result = num * (state.meta.isMobile ? state.commonRatio.Mobile.is : state.commonRatio.Mobile.not) * state.commonRatio.Lang[lang];
            return result;
          };
          var direction = state.bg.currentDirection;
          var baseWidth = 0;
          if (direction === 'vertical') {
            baseWidth = action.payload.verticalBg.width;
          } else if (direction === 'loop') {
            var previewx = action.payload.previewContainer.width;
            var previewy = action.payload.previewContainer.height;
            baseWidth = previewx > previewy ? action.payload.verticalBg.height * 0.8 : action.payload.verticalBg.width * 0.9;
          } else {
            baseWidth = action.payload.horizontalBg.height;
          }
          if (baseWidth === 0) {
            baseWidth = action.payload.verticalBg.width;
          }
          if (baseWidth === 0) {
            baseWidth = action.payload.horizontalBg.height;
          }
          var FONT_RATIO = adjustByLangAndMobile(baseWidth / state.charAndMotif.towelWidth * state.ratio[type].font);
          var font = FONT_RATIO * state.charAndMotif.selectedFontSize;
          var motif = FONT_RATIO * state.commonRatio.MotifFont * state.charAndMotif.motifSizeRatio / state.commonRatio.Lang[lang];
          return [font, motif];
        };
        var _getFontMotifSize = getFontMotifSize(),
          _getFontMotifSize2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__["default"])(_getFontMotifSize, 2),
          fontSize = _getFontMotifSize2[0],
          motifShowSize = _getFontMotifSize2[1];
        return _objectSpread(_objectSpread({}, state), {}, {
          charAndMotif: _objectSpread(_objectSpread({}, state.charAndMotif), {}, {
            motifShowSize: motifShowSize,
            fontSize: fontSize
          })
        });
      }
    case 'change_position':
      {
        var status = state.position.leftRightLoop === 'loop' ? 'loop' : '';
        var artLeft = '';
        var artTop = '';
        var artBottom = '';
        var artRight = '';
        var locateX = function locateX(width, toEdge) {
          artLeft = 'inherit';
          artRight = 'inherit';
          switch (state.position.leftRightLoop) {
            case 'left':
              artLeft = "".concat(width + toEdge, "px");
              break;
            case 'right':
              artRight = "".concat(width + toEdge, "px");
              break;
            // case 'center':
            // square should center ?
            // artRight = `${width + toEdge}px`;
            // break;
            case 'loop':
              if (state.position.topBottom === 'center') {
                artLeft = 'inherit';
              }
              break;
            default:
              break;
          }
          if (state.position.topBottom === state.position.leftRightLoop) {
            // only center center
            artRight = "".concat(width + toEdge, "px");
          }
        };
        var locateY = function locateY(height, toEdge) {
          artTop = 'inherit';
          artBottom = 'inherit';
          switch (state.position.topBottom) {
            // case 'center':
            //   artBottom = `${height + toEdge}px`;
            //   break;
            case 'top':
              artTop = "".concat(height + toEdge, "px");
              break;
            case 'bottom':
              artBottom = "".concat(height + toEdge, "px");
              break;
            default:
              break;
          }
          if (state.position.topBottom === state.position.leftRightLoop) {
            // only center center
            artBottom = "".concat(height + toEdge, "px");
          }
          if (status === 'loop') {
            artTop = "50%";
            artBottom = 'inherit';
          }
        };
        var getHeightOrWidth = function getHeightOrWidth(directionBg, whichEdge) {
          return (action.payload.previewContainer[whichEdge] - action.payload[directionBg][whichEdge]) / 2;
        };
        var getEdgeHeightOrWidth = function getEdgeHeightOrWidth(directionBg, whichEdge) {
          return action.payload[directionBg][whichEdge] * state.ratio[type][directionBg][whichEdge];
        };
        switch (state.bg.currentDirection) {
          case 'vertical':
            {
              if (state.bg.isSpecialShape) {
                var height = getHeightOrWidth('verticalBg', 'height');
                var toEdgeWidth = getEdgeHeightOrWidth('verticalBg', 'width');
                var toEdgeHeight = getEdgeHeightOrWidth('verticalBg', 'height');
                locateX(0, toEdgeWidth);
                locateY(height, toEdgeHeight);
                break;
              } else {
                var width = getHeightOrWidth('verticalBg', 'width');
                var _toEdgeHeight = getEdgeHeightOrWidth('verticalBg', 'height');
                var _toEdgeWidth = getEdgeHeightOrWidth('verticalBg', 'width');
                locateX(width, _toEdgeWidth);
                locateY(0, _toEdgeHeight);
                break;
              }
            }
          case 'horizontal':
            {
              var _height = getHeightOrWidth('horizontalBg', 'height');
              var _toEdgeWidth2 = getEdgeHeightOrWidth('horizontalBg', 'width');
              var _toEdgeHeight2 = getEdgeHeightOrWidth('horizontalBg', 'height');
              locateX(0, _toEdgeWidth2);
              locateY(_height, _toEdgeHeight2);
              break;
            }
          case 'loop':
            {
              locateX(0, 0);
              locateY(0, 0);
              break;
            }
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          position: _objectSpread(_objectSpread({}, state.position), {}, {
            artBottom: artBottom,
            artTop: artTop,
            artLeft: artLeft,
            artRight: artRight
          })
        });
      }
    case 'change_transform':
      {
        var transform = '';
        if (state.position.leaningLying !== 'leaning' && state.position.leftRightLoop !== 'loop') {
          return _objectSpread(_objectSpread({}, state), {}, {
            position: _objectSpread(_objectSpread({}, state.position), {}, {
              transform: transform
            })
          });
        }
        var _status = state.position.leaningLying === 'leaning' ? 'leaning' : 'loop';
        var x = state.position.leftRightLoop;
        var y = state.position.topBottom;
        var motifLayout = action.payload.customize.motifLayout;
        var charNum = action.payload.customize.textLength;
        if (_status === 'leaning') {
          var yDistance = 0;
          var xDistance = 0;
          var rotateDeg = x === 'right' ? '315' : '45';
          if (state.bg.isSquareShape) {
            yDistance += action.payload.verticalBg.width / 8;
          }

          // triangle
          yDistance = action.payload.artContainer.width / 2 / Math.sqrt(2);
          if (action.payload.customize.motifShow) {
            if (['左にモチーフ', 'おまかせ', '右にモチーフ'].includes(motifLayout)) {
              yDistance -= state.charAndMotif.motifShowSize * 0.2;
              if (charNum > 5) {
                var sign = x === 'right' ? 1 : -1;
                xDistance = state.charAndMotif.motifShowSize * 0.4 * sign;
              }
            }
            if (motifLayout === '下にモチーフ') {
              yDistance -= state.charAndMotif.motifShowSize * 0.5;
            }
            if (motifLayout === '上にモチーフ') {
              var _sign = x === 'right' ? -1 : 1;
              xDistance += state.charAndMotif.motifShowSize * 0.4 * _sign;
            }
            if (type === 'MFT') {
              yDistance = yDistance / 2;
              xDistance = xDistance / 2;
            }
          }
          yDistance = -1 * yDistance;
          transform = "translateY(".concat(yDistance, "px) rotate(").concat(rotateDeg, "deg) translateX(").concat(xDistance, "px)");
        }
        if (_status === 'loop') {
          var previewx = action.payload.previewContainer.width * 0.5;
          var previewy = action.payload.previewContainer.height * 0.45;
          var addedFirstValue = previewx > previewy ? 1.1 : 1;
          var addedNumValue = previewx > previewy ? 1 : 0.8;
          var firstDistance = state.charAndMotif.motifShowSize * addedFirstValue;
          var numDistance = charNum < 10 ? charNum * state.commonRatio.Loop[isMobile] * state.charAndMotif.selectedFontSize * addedNumValue : 10 * state.commonRatio.Loop[isMobile] * state.charAndMotif.selectedFontSize * addedNumValue;
          var ySign = y === 'top' ? -1 : 1;
          var _yDistance = previewx > previewy ? previewy : previewx;
          _yDistance = (_yDistance - firstDistance - numDistance) * ySign;
          transform = "translateY(".concat(_yDistance, "px)");
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          position: _objectSpread(_objectSpread({}, state.position), {}, {
            transform: transform
          })
        });
      }
    case 'find_shape':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          bg: _objectSpread(_objectSpread({}, state.bg), {}, {
            isSpecialShape: action.payload
          })
        });
      }
    default:
      return state;
  }
};

/***/ }),

/***/ "./src/ts/utils/contexts/ProductContext.tsx":
/*!**************************************************!*\
  !*** ./src/ts/utils/contexts/ProductContext.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProductContext": () => (/* binding */ ProductContext),
/* harmony export */   "ProductProvider": () => (/* binding */ ProductProvider)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _ProductReducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ProductReducer */ "./src/ts/utils/contexts/ProductReducer.tsx");




var ProductContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  productState: _ProductReducer__WEBPACK_IMPORTED_MODULE_2__.productStateValue,
  productDispatch: function productDispatch() {
    return null;
  }
});
ProductContext.displayName = 'ProductContext';
var ProductProvider = function ProductProvider(_ref) {
  var children = _ref.children;
  var _useReducer = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(_ProductReducer__WEBPACK_IMPORTED_MODULE_2__.productReducer, _ProductReducer__WEBPACK_IMPORTED_MODULE_2__.productStateValue),
    _useReducer2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useReducer, 2),
    productState = _useReducer2[0],
    productDispatch = _useReducer2[1];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(ProductContext.Provider, {
    value: {
      productState: productState,
      productDispatch: productDispatch
    }
  }, children);
};

/***/ }),

/***/ "./src/ts/utils/contexts/ProductReducer.tsx":
/*!**************************************************!*\
  !*** ./src/ts/utils/contexts/ProductReducer.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "productReducer": () => (/* binding */ productReducer),
/* harmony export */   "productStateValue": () => (/* binding */ productStateValue)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants */ "./src/ts/utils/constants.ts");
/* harmony import */ var _type_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../type.helper */ "./src/ts/utils/type.helper.ts");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var previewValue = {
  customizable: true,
  onlyChar: false,
  onlyMotif: false,
  sisyuNormal: true,
  sisyuDisney: true,
  sisyuStarwars: true,
  isGiftbox: true,
  giftboxSet: true,
  isWrapping: true,
  wrappingSet: true,
  yahoo: true,
  isPreviewable: true,
  isMask: true,
  jNumber: 0,
  eNumber: 0,
  positions: [''],
  width: 0,
  height: 0
};
var currentVariantValue = {
  index: 0,
  variantId: 1,
  sku: '',
  title: '',
  price: 0,
  compare_at_price: 0,
  inventory: 1,
  quantity: 1,
  available: true,
  color: ''
};
var productVariantValue = {
  id: 0,
  featured_image: {
    src: ''
  },
  title: '',
  sku: '',
  price: 0,
  compare_at_price: 0,
  available: true
};
var productValue = {
  available: true,
  id: 0,
  price: 0,
  compare_at_price: 0,
  type: '',
  vendor: '',
  description: '',
  title: '',
  featured_image: '',
  images: [''],
  variants: [productVariantValue],
  tags: ['']
};
var addtionalValue = {
  isCustomized: false
};
var customizeValue = {
  showType: _type_helper__WEBPACK_IMPORTED_MODULE_2__.ShowType.BOTH,
  characterId: 6270116069525,
  characterSize: 'おまかせ',
  characterName: 'ローマ字 ①',
  characterFont: '',
  characterColor: 'おまかせ(カッコイイ系)',
  characterText: '',
  characterCode: '#222',
  motifId: '',
  motifIchihiroId: '',
  motifShopifyId: 6208882376853,
  motifName: '',
  motifLayout: 'おまかせ',
  motifPath: '',
  motifShow: false,
  position: 'おまかせ',
  positionId: 'centerCenter'
};
var productStateValue = {
  submitting: false,
  panelOpen: true,
  motifParentCategory: '',
  additional: addtionalValue,
  currentVariant: currentVariantValue,
  product: productValue,
  preview: previewValue,
  customize: customizeValue,
  _uuidForTowel: '',
  errorMessage: ''
};
var productReducer = function productReducer(state, action) {
  var _action$variant$avail, _action$size, _action$shopifyId;
  switch (action.type) {
    case _constants__WEBPACK_IMPORTED_MODULE_1__.ProductPage.TOGGLE_SUBMITTING:
      return _objectSpread(_objectSpread({}, state), {}, {
        submitting: !state.submitting
      });
    case _constants__WEBPACK_IMPORTED_MODULE_1__.ProductPage.TOGGLE_PANEL:
      // if true turns to false
      var showType = state.panelOpen ? _type_helper__WEBPACK_IMPORTED_MODULE_2__.ShowType.HIDE // close panel
      : state.customize.showType !== _type_helper__WEBPACK_IMPORTED_MODULE_2__.ShowType.HIDE ? state.customize.showType : state.preview.onlyChar ? _type_helper__WEBPACK_IMPORTED_MODULE_2__.ShowType.ONLY_CHAR : state.preview.onlyMotif ? _type_helper__WEBPACK_IMPORTED_MODULE_2__.ShowType.ONLY_MOTIF : _type_helper__WEBPACK_IMPORTED_MODULE_2__.ShowType.BOTH;
      return _objectSpread(_objectSpread({}, state), {}, {
        panelOpen: !state.panelOpen,
        customize: _objectSpread(_objectSpread({}, state.customize), {}, {
          showType: showType
        })
      });
    case _constants__WEBPACK_IMPORTED_MODULE_1__.ProductPage.CHANGE_VARIANT:
      var index = action.variant.index === 0 ? 0 : action.variant.index || state.currentVariant.index;
      var variantId = action.variant.variantId || state.currentVariant.variantId;
      var sku = action.variant.sku || state.currentVariant.sku;
      var title = action.variant.title || state.currentVariant.title;
      var price = action.variant.price || state.currentVariant.price;
      var compare_at_price = action.variant.compare_at_price || state.currentVariant.compare_at_price;
      var color = action.variant.color || state.currentVariant.color;
      var tmpQuantity = action.variant.quantity ? state.currentVariant.quantity + action.variant.quantity : state.currentVariant.quantity;
      var quantity = Math.abs(tmpQuantity);
      var inventory = action.variant.inventory || state.currentVariant.inventory;
      var available = (_action$variant$avail = action.variant.available) !== null && _action$variant$avail !== void 0 ? _action$variant$avail : state.currentVariant.available;
      return _objectSpread(_objectSpread({}, state), {}, {
        currentVariant: _objectSpread(_objectSpread({}, state.currentVariant), {}, {
          index: index,
          variantId: variantId,
          color: color,
          sku: sku,
          title: title,
          price: price,
          compare_at_price: compare_at_price,
          quantity: quantity,
          inventory: inventory,
          available: available
        })
      });
    case _constants__WEBPACK_IMPORTED_MODULE_1__.ProductPage.INIT_PRODUCT_PAGE:
      {
        var _product$variants$0$f, _localStorage$getItem;
        var product = action.product,
          preview = action.preview;

        /** image order adjust */
        if (product.variants.length && 'https:' + product.images[0] === ((_product$variants$0$f = product.variants[0].featured_image) === null || _product$variants$0$f === void 0 ? void 0 : _product$variants$0$f.src)) {
          product.images.unshift(product.images[product.images.length - 1]);
          product.images.pop();
        }
        var accessType = performance.navigation.type;
        var searchQuery = new URLSearchParams(decodeURIComponent(location.search.substring(1)));
        var currentVariant = _objectSpread(_objectSpread({}, currentVariantValue), {}, {
          sku: action.product.variants[0].sku,
          variantId: action.product.variants[0].id,
          title: action.product.variants[0].title,
          available: action.product.variants[0].available,
          price: action.product.variants[0].price,
          compare_at_price: action.product.variants[0].compare_at_price,
          color: action.color
        });
        var customize = state.customize;
        var _uuidForTowel = state._uuidForTowel;
        var panelOpen = false;
        var openAndScrollToPanel = function openAndScrollToPanel(fromCart) {
          panelOpen = true;
          var panel = document.getElementById('t-product-towel-customization');
          if (panel && fromCart && accessType !== 1) {
            requestAnimationFrame(function () {
              panel.scrollIntoView({
                behavior: 'smooth'
              });
            });
          }
        };
        if (accessType !== 1) {
          // not reload
          if (searchQuery.get('customize') && searchQuery.get('customize') !== 'undefined') {
            // from cart with query
            customize = JSON.parse(searchQuery.get('customize'));
            openAndScrollToPanel(true);
          } else {
            customize = _objectSpread(_objectSpread({}, customize), {}, {
              showType: _type_helper__WEBPACK_IMPORTED_MODULE_2__.ShowType.HIDE
            });
          }
          if (searchQuery.get('currentVariant') && searchQuery.get('currentVariant') !== 'undefined') {
            // from cart with query
            currentVariant = JSON.parse(searchQuery.get('currentVariant'));
          }
        } else {
          // reload use ls cache
          var customizeCache = localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_1__.TOWEL_LOCAL_STORAGE_PRODUCT_CUSTOMIZE_DATA);
          if (customizeCache) {
            customize = JSON.parse(customizeCache).customize;
            currentVariant = JSON.parse(customizeCache).currentVariant;
          }
        }
        if (searchQuery.get('_uuidForTowel') && searchQuery.get('_uuidForTowel') !== 'undefined') {
          _uuidForTowel = searchQuery.get('_uuidForTowel');
        }
        var isPanelOpen = JSON.parse((_localStorage$getItem = localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_1__.TOWEL_LOCAL_STORAGE_PANEL_OPEN)) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : 'false');
        if (accessType === 1 && isPanelOpen) {
          openAndScrollToPanel(false);
        }
        var motifParentCategory = '';
        if (preview && preview.isMask) {
          motifParentCategory = 'mmt';
        } else if (preview.sisyuDisney) {
          motifParentCategory = 'tmt';
        } else if (preview.customizable) {
          motifParentCategory = 'tmm';
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          currentVariant: currentVariant,
          product: product,
          preview: preview,
          customize: customize,
          _uuidForTowel: _uuidForTowel,
          panelOpen: panelOpen,
          motifParentCategory: motifParentCategory
        });
      }
    case _constants__WEBPACK_IMPORTED_MODULE_1__.ProductPage.SUBMIT_ADD_CART:
      return state;
    case _constants__WEBPACK_IMPORTED_MODULE_1__.ProductPage.CUSTOMIZE_OPTION_CHANGE:
      var field = action.field,
        value = action.value;
      return _objectSpread(_objectSpread({}, state), {}, {
        customize: _objectSpread(_objectSpread({}, state.customize), {}, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, field, value))
      });
    case _constants__WEBPACK_IMPORTED_MODULE_1__.ProductPage.FETCH_ONE_MOTIF:
      return _objectSpread(_objectSpread({}, state), {}, {
        customize: _objectSpread(_objectSpread({}, state.customize), {}, {
          motifId: action.id,
          motifIchihiroId: action.ichihiroId,
          motifSize: (_action$size = action.size) !== null && _action$size !== void 0 ? _action$size : 'L',
          motifName: action.name,
          motifShopifyId: (_action$shopifyId = action.shopifyId) !== null && _action$shopifyId !== void 0 ? _action$shopifyId : undefined,
          motifShow: true,
          motifPath: action.path
        })
      });
    case _constants__WEBPACK_IMPORTED_MODULE_1__.ProductPage.EMPTY_ALL_CUSTOMIZE:
      {
        var _customize;
        var emptyCustomize = {
          showType: _type_helper__WEBPACK_IMPORTED_MODULE_2__.ShowType.HIDE,
          motifId: '',
          motifIchihiroId: '',
          motifName: '',
          motifShopifyId: '',
          motifShow: '',
          motifPath: '',
          characterText: '',
          characterName: '',
          characterFont: '',
          characterId: '',
          characterColor: '',
          characterCode: '',
          characterSize: '',
          motifLayout: '',
          position: '',
          positionId: ''
        };
        if (action.isInit) {
          _customize = state.preview.customizable ? state.customize : emptyCustomize;
        } else {
          _customize = state.panelOpen ? state.customize : emptyCustomize;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          customize: _customize
        });
      }
    case _constants__WEBPACK_IMPORTED_MODULE_1__.ProductPage.CHANGE_ERROR_MESSAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        errorMessage: action.errorMessage
      });
    default:
      return state;
  }
};

/***/ }),

/***/ "./src/ts/utils/helpers.ts":
/*!*********************************!*\
  !*** ./src/ts/utils/helpers.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MotifAxios": () => (/* binding */ MotifAxios),
/* harmony export */   "hideLoader": () => (/* binding */ hideLoader),
/* harmony export */   "isShippingMethodOrInit": () => (/* binding */ isShippingMethodOrInit)
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! axios */ "./node_modules/axios/index.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);

var MotifAxios = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
  baseURL: 'https://ichihiroshopify.microcms.io/api/v1/',
  headers: {
    'X-API-KEY': '68caef7c-7828-4610-8ade-df084b3665c5'
  }
});
var hideLoader = function hideLoader() {
  var loader = document.querySelector('.loader-container');
  loader.style.opacity = '0';
  loader.remove();
};
var isShippingMethodOrInit = function isShippingMethodOrInit(checkoutMethod) {
  if (!checkoutMethod) {
    return true;
  }
  if (checkoutMethod === 'shipping') {
    return true;
  }
  return false;
};

/***/ }),

/***/ "./src/ts/utils/jaLocal.ts":
/*!*********************************!*\
  !*** ./src/ts/utils/jaLocal.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jaLocale": () => (/* binding */ jaLocale)
/* harmony export */ });
var jaLocale = {
  // months list by order
  months: ['１月', '２月', '３月', '４月', '５月', '６月', '７月', '８月', '９月', '１０月', '１１月', '１２月'],
  // week days by order
  weekDays: [{
    name: '日曜日',
    // used for accessibility
    "short": '日',
    // displayed at the top of days' rows
    isWeekend: true // is it a formal weekend or not?
  }, {
    name: '月曜日',
    "short": '月'
  }, {
    name: '火曜日',
    "short": '火'
  }, {
    name: '水曜日',
    "short": '水'
  }, {
    name: '木曜日',
    "short": '木'
  }, {
    name: '金曜日',
    "short": '金'
  }, {
    name: '土曜日',
    "short": '土',
    isWeekend: true
  }],
  // just play around with this number between 0 and 6
  weekStartingIndex: 0,
  // return a  object
  getToday: function getToday(gregorainTodayObject) {
    return gregorainTodayObject;
  },
  // return a native JavaScript date here
  toNativeDate: function toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
  },
  // return a number for date's month length
  getMonthLength: function getMonthLength(date) {
    return new Date(date.year, date.month, 0).getDate();
  },
  // return a transformed digit to your locale
  transformDigit: function transformDigit(digit) {
    return digit;
  },
  // texts in the date picker
  nextMonth: 'Next Month',
  previousMonth: 'Previous Month',
  openMonthSelector: 'Open Month Selector',
  openYearSelector: 'Open Year Selector',
  closeMonthSelector: 'Close Month Selector',
  closeYearSelector: 'Close Year Selector',
  defaultPlaceholder: '日付選択',
  // for input range value
  from: 'from',
  to: 'to',
  // used for input value when multi dates are selected
  digitSeparator: ',',
  // if your provide -2 for example, year will be 2 digited
  yearLetterSkip: 0,
  // is your language rtl or ltr?
  isRtl: false
};

/***/ }),

/***/ "./src/ts/utils/productActions.ts":
/*!****************************************!*\
  !*** ./src/ts/utils/productActions.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "handleShowTypeSelect": () => (/* binding */ handleShowTypeSelect)
/* harmony export */ });
/* harmony import */ var _type_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./type.helper */ "./src/ts/utils/type.helper.ts");

var handleShowTypeSelect = function handleShowTypeSelect(mutate, index) {
  mutate('showType', index);
  switch (index) {
    case _type_helper__WEBPACK_IMPORTED_MODULE_0__.ShowType.ONLY_CHAR:
      mutate('motifId', '');
      mutate('motifShow', '');
      mutate('motifPath', '');
      break;
    case _type_helper__WEBPACK_IMPORTED_MODULE_0__.ShowType.BOTH:
      break;
    case _type_helper__WEBPACK_IMPORTED_MODULE_0__.ShowType.ONLY_MOTIF:
      mutate('characterText', '');
      break;
    default:
      break;
  }
};

/***/ }),

/***/ "./src/ts/utils/type.helper.ts":
/*!*************************************!*\
  !*** ./src/ts/utils/type.helper.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CHART_LIMIT_IN_GIFT": () => (/* binding */ CHART_LIMIT_IN_GIFT),
/* harmony export */   "CartStepEnum": () => (/* binding */ CartStepEnum),
/* harmony export */   "ItemStatus": () => (/* binding */ ItemStatus),
/* harmony export */   "MessageCardArr": () => (/* binding */ MessageCardArr),
/* harmony export */   "NoshiArr": () => (/* binding */ NoshiArr),
/* harmony export */   "ProductType": () => (/* binding */ ProductType),
/* harmony export */   "ShopifyGift": () => (/* binding */ ShopifyGift),
/* harmony export */   "ShowType": () => (/* binding */ ShowType),
/* harmony export */   "charHandles": () => (/* binding */ charHandles),
/* harmony export */   "character": () => (/* binding */ character),
/* harmony export */   "customizableTypes": () => (/* binding */ customizableTypes),
/* harmony export */   "embroPositions": () => (/* binding */ embroPositions),
/* harmony export */   "motif": () => (/* binding */ motif),
/* harmony export */   "motifHandles": () => (/* binding */ motifHandles),
/* harmony export */   "motifSize": () => (/* binding */ motifSize)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");

var _ShopifyGift;
var character = {
  fonts: [{
    name: 'ローマ字 ①',
    characterId: 6270116069525,
    font: 'font-lato',
    word: 'Towel',
    css: 'Lato'
  }, {
    name: 'ローマ字 ②',
    characterId: 6270131732629,
    font: 'font-pinyon',
    word: 'Towel',
    css: 'Pinyon Script'
  }, {
    name: 'ローマ字 ③',
    characterId: 6270142808213,
    font: 'font-hobo',
    word: 'Towel',
    css: 'hobo-std'
  }, {
    name: 'ひらがな',
    characterId: 6270153982101,
    font: 'font-kosugi',
    word: 'たおる',
    css: 'Kosugi Maru'
  }, {
    name: 'カタカナ',
    characterId: 6270179606677,
    font: 'font-noto',
    word: 'タオル',
    css: 'Noto Sans JP'
  }],
  sizes: ['おまかせ', '1.0cm', '1.2cm', '1.5cm', '2.0cm']
};
var motif = {
  motifs: [6208882376853, 6208870678677, 6240666779797, 6208866418837, 6208878084245],
  layouts: [{
    name: 'おまかせ',
    flex: 'flex-row',
    src: 'left'
  }, {
    name: '左にモチーフ',
    flex: 'flex-row',
    src: 'left'
  }, {
    name: '右にモチーフ',
    flex: 'flex-row-reverse',
    src: 'right'
  }, {
    name: '上にモチーフ',
    flex: 'flex-col',
    src: 'top'
  }, {
    name: '下にモチーフ',
    flex: 'flex-col-reverse',
    src: 'bottom'
  }]
};
var motifHandles = {
  6208882376853: 'towel-motif-icon-mmt',
  6208870678677: 'towel-motif-icon-tmt',
  6240666779797: 'towel-motif-icon-tmt-xlarge',
  6208866418837: 'towel-motif-icon-tmt-large',
  6208878084245: 'towel-motif-icon-tmm'
};
var charHandles = {
  6270116069525: 'towel-sisyu-character-0',
  6270131732629: 'towel-sisyu-character-1',
  6270142808213: 'towel-sisyu-character-2',
  6270153982101: 'towel-sisyu-character-3',
  6270179606677: 'towel-sisyu-character-4'
};
var embroPositions = [{
  name: 'おまかせ',
  id: 'centerCenter'
}, {
  name: '上部中央上',
  id: 'topCenter'
}, {
  name: '上部左上',
  id: 'topLeft'
}, {
  name: '上部右上',
  id: 'topRight'
}, {
  name: '下部中央下',
  id: 'bottomCenter'
}, {
  name: '下部左下',
  id: 'bottomLeft'
}, {
  name: '下部右下',
  id: 'bottomRight'
}, {
  name: '下部左斜め下',
  id: 'bottomLeftLeaning'
}, {
  name: '下部右斜め下',
  id: 'bottomRightLeaning'
}, {
  name: '左下\n【タオル横向き】',
  id: 'bottomLeftLying'
}, {
  name: '右下\n【タオル横向き】',
  id: 'bottomRightLying'
}, {
  name: '下部左斜め下\n【タオル横向き】',
  id: 'bottomLeftLeaningLying'
}, {
  name: '下部右斜め下\n【タオル横向き】',
  id: 'bottomRightLeaningLying'
}, {
  name: 'ループ上',
  id: 'topLoop'
}, {
  name: 'ループ下',
  id: 'bottomLoop'
}];
var motifSize = {
  S: {
    name: 'S',
    ratio: 1.6
  },
  M: {
    name: 'M',
    ratio: 2
  },
  L: {
    name: 'L',
    ratio: 4
  },
  XL: {
    name: 'XL',
    ratio: 8
  }
};
var ProductType = /*#__PURE__*/function (ProductType) {
  ProductType["TOWEL"] = "towel";
  ProductType["CHAR"] = "character";
  ProductType["MOTIF"] = "motif";
  ProductType["GIFT_BOX"] = "giftbox";
  ProductType["WRAPPING"] = "wrapping";
  ProductType["PICKUP"] = "pickup";
  return ProductType;
}({});
var MessageCardArr = ['アヒル', 'シンプル', 'スター', 'とり', 'プレゼント', '花'];
var NoshiArr = ['記念品', '御結婚御祝', '御祝', '御出産御祝', '御礼', '内祝(十本結切)', '内祝(蝶結)', 'リボン'];
var ShopifyGift = (_ShopifyGift = {}, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_ShopifyGift, ProductType.GIFT_BOX, 37828691918997), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_ShopifyGift, ProductType.WRAPPING, 37828693983381), _ShopifyGift);
var ItemStatus = /*#__PURE__*/function (ItemStatus) {
  ItemStatus[ItemStatus["UNSELECT"] = 0] = "UNSELECT";
  ItemStatus[ItemStatus["SELECTED"] = 1] = "SELECTED";
  ItemStatus[ItemStatus["CONFIRMED"] = 2] = "CONFIRMED";
  return ItemStatus;
}({});
var CartStepEnum = /*#__PURE__*/function (CartStepEnum) {
  CartStepEnum[CartStepEnum["ADD_GIFT"] = 0] = "ADD_GIFT";
  CartStepEnum[CartStepEnum["ASSIGN_GIFT"] = 1] = "ASSIGN_GIFT";
  CartStepEnum[CartStepEnum["UPDATE_GIFT"] = 2] = "UPDATE_GIFT";
  CartStepEnum[CartStepEnum["LOCATION"] = 3] = "LOCATION";
  CartStepEnum[CartStepEnum["PAYMENT"] = 4] = "PAYMENT";
  return CartStepEnum;
}({});
var ShowType = /*#__PURE__*/function (ShowType) {
  ShowType[ShowType["ONLY_CHAR"] = 0] = "ONLY_CHAR";
  ShowType[ShowType["BOTH"] = 1] = "BOTH";
  ShowType[ShowType["ONLY_MOTIF"] = 2] = "ONLY_MOTIF";
  ShowType[ShowType["HIDE"] = 3] = "HIDE";
  return ShowType;
}({});
var CHART_LIMIT_IN_GIFT = 20;
var customizableTypes = ['マスク', 'スタイ', 'エプロンスタイ', '襟付きスタイ', 'タオルケット', 'フード付きBT', 'ポンチョ', 'ベスト', 'スリーパー', 'エプロン', 'サロン', 'ミニバッグ', 'ランチバック', 'トートバック', '巾着', '差し込みマフラー', 'ロングポシェチーフ', '特殊アイテム', 'ギフト'];
window.Towel = window.Towel || {};

/***/ })

}]);